import {
  Fragment,
  useEffect,
  useState,
  useRef,
  useContext,
  createRef,
} from "react";

import stylesRequestData from "./RequestData.module.css";
import SearchSelectElement from "../../../shared/form/SearchSelectElement";
import {
  getPaymentCommitteeDistricts,
  getPaymentVillages,
  getPaymentRegions,
  getPaymentBuild,
  getAppealPaymentUnit,
  getFloorsByRealEstateId,
} from "../../../adapters/apis/lookups/lookups";
import { post } from "../../../adapters/xhr/api";
import { validateNationalID } from "../../../helpers/Validation";
import TextAreaElement from "../../../shared/form/TextAreaElement";
import InputElement from "../../../shared/form/InputElement";
import TaxAppealContext from "../../../contexts/TaxAppealProvider";
import { Link, useNavigate } from "react-router-dom";
import { validateRequired } from "../../../helpers/Validation";
import { verifyUnitCode } from "../../../adapters/apis/taxAppeal/details";
import AttachmentName from "../../../helpers/AttachmentName";
import DownloadFile from "../../../helpers/DownloadFile";

const AppealRequestData = ({
  user,
  appealReasonTypes,
  appealTypes,
  appealTaxPeriods,
  govs,
  nationalitiesTypes,
  submitterTypes,
  unitAddressTypes,
  unitOwnerTypes,
  unitTypes,
  facilityTypes,
  doYouWantExtraAttachments,
}) => {
  const taxAppealContext = useContext(TaxAppealContext);
  const { appealRequest, updateAppealRequest, setAppealRequest } =
    taxAppealContext;

  const navigate = useNavigate();
  const agencyFileInputRef = useRef();
  const nationalIdFileInputRef = useRef();
  const passportNumFileInputRef = useRef();
  const commercialRegistrationNumberInputRef = useRef();
  const taxNumberFileInputRef = useRef();
  const otherEntityFileInputRef = useRef();
  const documentFileInputRef = useRef({});
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [
    isButtonDisabledIfAttachmentFilesAreNotValid,
    setIsButtonDisabledIfAttachmentFilesAreNotValid,
  ] = useState(false);

  const [backendError, setBackendError] = useState(null);
  const [submissionError, setSubmissionError] = useState(null);
  const [uploadFileError, setUploadFileError] = useState(null);
  const [isValid, setIsValid] = useState(false);
  const [unitIsVerified, setUnitIsVerified] = useState(false);
  const [fileErrors, setFileErrors] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [villages, setVillages] = useState([]);
  const [regions, setRegions] = useState([]);
  const [realEstates, setRealEstates] = useState([]);
  const [floors, setFloors] = useState([]);
  const [units, setUnits] = useState([]);
  const [unitOwnerTypeErrorMessage, setUnitOwnerTypeErrorMessage] =
    useState("");
  const [inputKeys, setInputKeys] = useState({}); // const [appealRequest] = useState(
  //   appealRequest || {}
  // );
  const [validFields, setValidFields] = useState({
    submitter_type_id: false,
    other_submitter_type_text: false,
    unit_owner_type_id: false,
    unit_owner_first_name: false,
    unit_owner_rest_name: false,
    unit_owner_nationality_id: false,
    unit_owner_national_id: false,
    unit_owner_national_id_attachment: false,
    unit_owner_passport_no: false,
    unit_owner_passport_no_attachment: false,
    unit_owner_name: false,
    commercial_registration_number: false,
    commercial_registration_number_attachment: false,
    tax_number: false,
    tax_number_attachment: false,
    unit_owner_other: false,
    unit_owner_other_attachment: false,
    appeal_type_id: false,

    appeal_rental_value: false,
    appeal_tax_value: false,
    appealed_tax_period_type_id: false,
    appeal_reasons: false,
    appeal_reason_type_id: false,
    other_appeal_reason_type_text: false,

    unit_code: false,
    governorate_text: false,
    district_text: false,
    village_text: false,
    street_text: false,
    build_text: false,
    floor_text: false,
    unit_text: false,
    unit_address_type_id: false,
    governorate_id: false,
    district_id: false,
    village_id: false,
    other_village_text: false,
    region_id: false,
    other_region_text: false,
    real_estate_id: false,
    other_real_estate_text: false,
    floor_id: false,
    unit_id: false,
    other_unit_text: false,
    unit_type_id: false,
    facility_unit_type_id: false,

    has_additional_attachments: false,
    name: false,
    file: false,

    legal_representative_attachment: false,
    property_address: false,
    activity_address: false,

    acknowledge_not_submitted_same_data_before: false,
    acknowledge_all_documents_are_correct: false,
    acknowledge_unwillingness_submit_via_digital: false,
  });

  const [error_new_user, setNewUserError] = useState(
    Object.keys(appealRequest || {})?.reduce((acc, key) => {
      acc[key] = "";
      return acc;
    }, {}),
  );

  const [fileInputKeys, setFileInputKeys] = useState({
    agency: Date.now(),
    appeal: Date.now(),
    tax: Date.now(),
  });

  function setError(key, value) {
    setNewUserError((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  const nationalitesOptions = nationalitiesTypes?.map((element) => {
    return { value: element.id, label: element.name };
  });

  const handleNationalityChange = () => {
    setError("unit_owner_national_id", "");
    setError("unit_owner_national_id_attachment", "");
    setError("unit_owner_passport_no", "");
    setError("unit_owner_passport_no_attachment", "");
    setValidFields((prev) => ({
      ...prev,
      unit_owner_national_id: false,
      unit_owner_national_id_attachment: false,
      unit_owner_passport_no: false,
      unit_owner_passport_no_attachment: false,
    }));
    setAppealRequest((prev) => ({
      ...prev,
      unit_owner_national_id: null,
      unit_owner_passport_no: null,
      unit_owner_national_id_attachment: null,
      unit_owner_passport_no_attachment: null,
    }));
    if (nationalIdFileInputRef?.current) {
      nationalIdFileInputRef.current.value = null;
    }
    if (passportNumFileInputRef?.current) {
      passportNumFileInputRef.current.value = null;
    }
  };

  const handleOwnerUnitTypeOneChange = () => {
    setError("unit_owner_first_name", "");
    setError("unit_owner_rest_name", "");
    setError("unit_owner_nationality_id", "");

    setValidFields((prev) => ({
      ...prev,
      unit_owner_first_name: false,
      unit_owner_rest_name: false,
      unit_owner_nationality_id: false,
    }));
    setAppealRequest((prev) => ({
      ...prev,
      unit_owner_first_name: null,
      unit_owner_rest_name: null,
      unit_owner_nationality_id: null,
    }));
    handleNationalityChange();
  };

  const handleOwnerUnitTypeTwoChange = () => {
    setError("unit_owner_name", "");
    setError("commercial_registration_number", "");
    setError("commercial_registration_number_attachment", "");
    setError("tax_number", "");
    setError("tax_number_attachment", "");
    setError("unit_owner_other", "");
    setError("unit_owner_other_attachment", "");

    setValidFields((prev) => ({
      ...prev,
      unit_owner_name: false,
      commercial_registration_number: false,
      commercial_registration_number_attachment: false,
      tax_number: false,
      tax_number_attachment: false,
      unit_owner_other: false,
      unit_owner_other_attachment: false,
    }));

    setAppealRequest((prev) => ({
      ...prev,
      unit_owner_name: null,
      commercial_registration_number: null,
      commercial_registration_number_attachment: null,
      tax_number: null,
      tax_number_attachment: null,
      unit_owner_other: null,
      unit_owner_other_attachment: null,
    }));

    if (commercialRegistrationNumberInputRef?.current) {
      commercialRegistrationNumberInputRef.current.value = null;
    }
    if (taxNumberFileInputRef?.current) {
      taxNumberFileInputRef.current.value = null;
    }
    if (otherEntityFileInputRef?.current) {
      otherEntityFileInputRef.current.value = null;
    }
  };

  useEffect(() => {
    if (
      parseInt(appealRequest?.unit_owner_type_id) === 2 &&
      (appealRequest?.commercial_registration_number == null ||
        appealRequest?.commercial_registration_number == "")
    ) {
      setError("commercial_registration_number", "");
      setError("commercial_registration_number_attachment", "");
      setValidFields((prev) => ({
        ...prev,
        commercial_registration_number_attachment: false,
      }));

      setAppealRequest((prev) => ({
        ...prev,
        commercial_registration_number_attachment: null,
      }));

      commercialRegistrationNumberInputRef.current.value = null;
    }
  }, [
    appealRequest?.unit_owner_type_id,
    appealRequest?.commercial_registration_number,
  ]);

  useEffect(() => {
    if (
      parseInt(appealRequest?.unit_owner_type_id) === 2 &&
      (appealRequest?.tax_number == null || appealRequest?.tax_number == "")
    ) {
      setError("tax_number", "");
      setError("tax_number_attachment", "");
      setValidFields((prev) => ({
        ...prev,
        tax_number_attachment: false,
      }));

      setAppealRequest((prev) => ({
        ...prev,
        tax_number_attachment: null,
      }));

      taxNumberFileInputRef.current.value = null;
    }
  }, [appealRequest?.unit_owner_type_id, appealRequest?.tax_number]);

  useEffect(() => {
    if ([4, 5, 6].includes(parseInt(appealRequest?.submitter_type_id))) {
      if (
        !validateRequired(
          appealRequest?.legal_representative_attachment?.full_url,
        )
      ) {
        setError("legal_representative_attachment", "يجب رفع الصورة");
      } else {
        setError("legal_representative_attachment", "");
      }
    }
  }, [appealRequest?.submitter_type_id]);

  useEffect(() => {
    if (parseInt(appealRequest?.unit_owner_nationality_id) === 63) {
      if (
        !validateRequired(
          appealRequest?.unit_owner_national_id_attachment?.full_url,
        )
      ) {
        setError("unit_owner_national_id_attachment", "يجب رفع الصورة");
      } else {
        setError("unit_owner_national_id_attachment", "");
      }
    } else {
      if (
        !validateRequired(
          appealRequest?.unit_owner_passport_no_attachment?.full_url,
        )
      ) {
        setError("unit_owner_passport_no_attachment", "يجب رفع الصورة");
      } else {
        setError("unit_owner_passport_no_attachment", "");
      }
    }
  }, [appealRequest?.unit_owner_nationality_id]);

  useEffect(() => {
    if (parseInt(appealRequest?.unit_address_type_id) === 1) {
      if (!validateRequired(appealRequest?.unit_code)) {
        setValidFields((prev) => ({
          ...prev,
          unit_code: false,
        }));
        setError("unit_code", "يجب إدخال كود حساب الوحدة");
      } else if (appealRequest?.unit_code?.length !== 14) {
        setValidFields((prev) => ({
          ...prev,
          unit_code: false,
        }));
        setError("unit_code", "يجب إدخال كود الوحدة المكون من 14 رقمًا فقط");
      } else {
        setValidFields((prev) => ({
          ...prev,
          unit_code: true,
        }));
        setError("unit_code", "");
      }
    }
  }, [appealRequest?.unit_address_type_id, appealRequest?.unit_code]);

  useEffect(() => {
    if (
      parseInt(appealRequest?.unit_owner_type_id) === 2 &&
      (appealRequest?.unit_owner_other == null ||
        appealRequest?.unit_owner_other == "")
    ) {
      setError("unit_owner_other", "");
      setError("unit_owner_other_attachment", "");
      setValidFields((prev) => ({
        ...prev,
        unit_owner_other_attachment: false,
      }));

      setAppealRequest((prev) => ({
        ...prev,
        unit_owner_other_attachment: null,
      }));

      otherEntityFileInputRef.current.value = null;
    }
  }, [appealRequest?.unit_owner_type_id, appealRequest?.unit_owner_other]);

  useEffect(() => {
    if (validateRequired(appealRequest?.commercial_registration_number)) {
      if (
        !validateRequired(
          appealRequest?.commercial_registration_number_attachment?.full_url,
        )
      ) {
        setError("commercial_registration_number_attachment", "يجب رفع الصورة");
      } else {
        setError("commercial_registration_number_attachment", "");
      }
    }
  }, [appealRequest?.commercial_registration_number]);

  useEffect(() => {
    if (validateRequired(appealRequest?.tax_number)) {
      if (!validateRequired(appealRequest?.tax_number_attachment?.full_url)) {
        setError("tax_number_attachment", "يجب رفع الصورة");
      } else {
        setError("tax_number_attachment", "");
      }
    }
  }, [appealRequest?.tax_number]);

  useEffect(() => {
    if (validateRequired(appealRequest?.unit_owner_other)) {
      if (
        !validateRequired(appealRequest?.unit_owner_other_attachment?.full_url)
      ) {
        setError("unit_owner_other_attachment", "يجب رفع الصورة");
      } else {
        setError("unit_owner_other_attachment", "");
      }
    }
  }, [appealRequest?.unit_owner_other]);

  const handleRequestTypeChange = () => {
    setError("appeal_rental_value", "");
    setError("appeal_tax_value", "");
    setError("appealed_tax_period_type_id", "");
    setError("appeal_reasons", "");
    setError("appeal_reason_type_id", "");
    setError("other_appeal_reason_type_text", "");

    setValidFields((prev) => ({
      ...prev,
      appeal_rental_value: false,
      appeal_tax_value: false,
      appealed_tax_period_type_id: false,
      appeal_reasons: false,
      appeal_reason_type_id: false,
      other_appeal_reason_type_text: false,
    }));

    setAppealRequest((prev) => ({
      ...prev,
      appeal_rental_value: null,
      appeal_tax_value: null,
      appealed_tax_period_type_id: null,
      appeal_reasons: null,
      appeal_reason_type_id: null,
      other_appeal_reason_type_text: null,
    }));
  };

  const handleAddressTypeChange = () => {
    setUnitIsVerified(false);
    setError("unit_code", "");
    setError("governorate_id", "");
    setError("district_id", "");
    setError("village_id", "");
    setError("other_village_text", "");
    setError("region_id", "");
    setError("other_region_text", "");
    setError("real_estate_id", "");
    setError("other_real_estate_text", "");
    setError("floor_id", "");
    setError("unit_id", "");
    setError("other_unit_text", "");

    setValidFields((prev) => ({
      ...prev,
      unit_code: false,
      governorate_id: false,
      district_id: false,
      village_id: false,
      other_village_text: false,
      region_id: false,
      other_region_text: false,
      real_estate_id: false,
      other_real_estate_text: false,
      floor_id: false,
      unit_id: false,
      other_unit_text: false,
    }));

    setAppealRequest((prev) => ({
      ...prev,
      unit_code: null,
      governorate_text: null,
      district_text: null,
      village_text: null,
      street_text: null,
      build_text: null,
      floor_text: null,
      unit_text: null,

      governorate_id: null,
      district_id: null,
      village_id: null,
      other_village_text: null,
      region_id: null,
      other_region_text: null,
      real_estate_id: null,
      other_real_estate_text: null,
      floor_id: null,
      unit_id: null,
      other_unit_text: null,
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const data = {
          unit_code: appealRequest?.unit_code,
        };
        const verifyResponse = await verifyUnitCode(data);
        setAppealRequest((prev) => ({
          ...prev,
          governorate_text: verifyResponse?.data?.data?.governorate_text,
          district_text: verifyResponse?.data?.data?.district_text,
          village_text: verifyResponse?.data?.data?.village_text,
          street_text: verifyResponse?.data?.data?.street_text,
          build_text: verifyResponse?.data?.data?.build_text,
          floor_text: verifyResponse?.data?.data?.floor_text,
          unit_text: verifyResponse?.data?.data?.unit_text,
        }));
        setUnitIsVerified(true);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);

        setUnitIsVerified(false);
        setAppealRequest((prev) => ({
          ...prev,
          governorate_text: null,
          district_text: null,
          village_text: null,
          street_text: null,
          build_text: null,
          floor_text: null,
          unit_text: null,
        }));
        setBackendError(error.response?.data?.message || "هذا الكود غير موجود");
        window.scrollTo(0, 0);
      }
    };
    if (
      appealRequest?.unit_code &&
      parseInt(appealRequest?.unit_address_type_id) === 1
    ) {
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (parseInt(appealRequest?.has_additional_attachments) === 1) {
      if (appealRequest?.additional_attachments?.length === 0) {
        const singleAttachment = {
          id: Math.random(),
          name: null,
          file: null,
          original_file_name: null,
          path: null,
          full_url: null,
        };
        // setAttachments((prev) => [...prev, singleAttachment]);
        updateAppealRequest("additional_attachments", [
          ...(appealRequest?.additional_attachments || []),
          singleAttachment,
        ]);
        setFileErrors((prev) => ({ ...prev, [singleAttachment.id]: "" }));
      }
    } else {
      // setAttachments([]);
      setIsButtonDisabledIfAttachmentFilesAreNotValid(false);
      updateAppealRequest("additional_attachments", []);
    }
  }, [appealRequest?.has_additional_attachments]);

  const addAttachment = () => {
    const newDoc = {
      id: Math.random(),
      name: null,
      file: null,
      original_file_name: null,
      path: null,
      full_url: null,
    };

    // setAttachments((prev) => [...prev, newDoc]);
    updateAppealRequest("additional_attachments", [
      ...(appealRequest?.additional_attachments || []),
      newDoc,
    ]);
    setFileErrors((prev) => ({
      ...prev,
      [newDoc.id]: {
        name: "",
        file: "",
        original_file_name: "",
        path: "",
        full_url: "",
      },
    }));
  };

  const removeAttachmentById = (id) => {
    setIsButtonDisabledIfAttachmentFilesAreNotValid(false);
    // setAttachments((prev) => prev.filter((doc) => doc.id !== id));
    updateAppealRequest(
      "additional_attachments",
      (appealRequest?.additional_attachments || []).filter(
        (doc) => doc.id !== id,
      ),
    );
    setFileErrors((prev) => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
  };

  const updateDocumentName = (id, newName) => {
    // setAttachments((prev) =>
    //   prev.map((item) => (item.id === id ? { ...item, name: newName } : item))
    // );
    updateAppealRequest(
      "additional_attachments",
      (appealRequest?.additional_attachments || []).map((item) =>
        item.id === id ? { ...item, name: newName } : item,
      ),
    );
  };

  const updateDocumentFile = async (id, file) => {
    try {
      setIsButtonDisabledIfAttachmentFilesAreNotValid(true);
      const data = new FormData();
      data.append(`label`, "additional_attachments");
      data.append(`file`, file);
      if (file) {
        const response = await post(
          "api/tax-appeal/upload-attachments",
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          },
          data,
        );
        setIsButtonDisabledIfAttachmentFilesAreNotValid(false);

        updateAppealRequest(
          "additional_attachments",
          (appealRequest?.additional_attachments || []).map((item) =>
            item.id === id
              ? {
                  ...item,
                  file: response?.data?.data?.file,
                  original_file_name: response?.data?.data?.original_file_name,
                  path: response?.data?.data?.path,
                  full_url: response?.data?.data?.full_url,
                }
              : item,
          ),
        );
        setUploadFileError(null);
      }
    } catch (error) {
      setIsButtonDisabledIfAttachmentFilesAreNotValid(true);
      if (error.status === 422) {
        updateAppealRequest(
          "additional_attachments",
          (appealRequest?.additional_attachments || []).map((item) =>
            item.id === id
              ? {
                  ...item,
                  file: null,
                  original_file_name: null,
                  path: null,
                  full_url: null,
                }
              : item,
          ),
        );
        window.scrollTo(0, 0);
        // setError(key, "يجب رفع الصورة");
        setUploadFileError(error?.response?.data?.errors?.file);
      }
    }
  };

  const setFileErrorById = (id, field, message) => {
    setFileErrors((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: message,
      },
    }));
  };

  const validateAttachments = () => {
    const errors = {};

    appealRequest?.additional_attachments?.forEach((doc) => {
      errors[doc.id] = {
        name:
          doc.name === null || doc.name === "" ? "يجب إدخال اسم المستند" : "",
        file: doc.file === null ? "يجب رفع الصورة" : "",
      };
    });

    setFileErrors(errors);
  };

  useEffect(() => {
    validateAttachments();
  }, [appealRequest?.additional_attachments]);

  const scrollToElement = (element_name) => {
    const element = document.getElementById(element_name);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const validateBeforeSubmit = async () => {
    setIsSubmitting(true);

    let isFormValid = true;
    if (!validateRequired(appealRequest?.submitter_type_id)) {
      setValidFields((prev) => ({
        ...prev,
        submitter_type_id: false,
      }));
      setError("submitter_type_id", "يجب اختيار صفة مقدم الطلب");
      isFormValid = false;
      scrollToElement("submitter_type_id");
    } else {
      setError("submitter_type_id", "");
      setValidFields((prev) => ({
        ...prev,
        submitter_type_id: true,
      }));
    }

    if (parseInt(appealRequest?.submitter_type_id) === 6) {
      if (!validateRequired(appealRequest?.other_submitter_type_text)) {
        setValidFields((prev) => ({
          ...prev,
          other_submitter_type_text: false,
        }));
        setError("other_submitter_type_text", "يجب إدخال حقل أخرى");
        isFormValid = false;
        scrollToElement("other_submitter_type_text");
      } else {
        setError("other_submitter_type_text", "");
        setValidFields((prev) => ({
          ...prev,
          other_submitter_type_text: true,
        }));
      }
    }

    if ([4, 5, 6].includes(parseInt(appealRequest?.submitter_type_id))) {
      if (
        !validateRequired(
          appealRequest?.legal_representative_attachment?.full_url,
        )
      ) {
        setError("legal_representative_attachment", "يجب رفع الصورة");
        isFormValid = false;
        scrollToElement("legal_representative_attachment");
      } else {
        setError("legal_representative_attachment", "");
      }
      setValidFields((prev) => ({
        ...prev,
        legal_representative_attachment: true,
      }));

      if (!validateRequired(appealRequest?.unit_owner_type_id)) {
        setValidFields((prev) => ({
          ...prev,
          unit_owner_type_id: false,
        }));
        setError("unit_owner_type_id", "يجب اختيار نوع مالك الوحدة محل الطعن");
        isFormValid = false;
        scrollToElement("unit_owner_type_id");
      } else {
        setError("unit_owner_type_id", "");
        setValidFields((prev) => ({
          ...prev,
          unit_owner_type_id: true,
        }));
      }

      // طبيعي
      if (parseInt(appealRequest?.unit_owner_type_id) === 1) {
        if (!validateRequired(appealRequest?.unit_owner_first_name)) {
          setValidFields((prev) => ({
            ...prev,
            unit_owner_first_name: false,
          }));
          setError(
            "unit_owner_first_name",
            "يجب إدخال الإسم الأول لمالك الوحدة محل الطعن",
          );
          isFormValid = false;
          scrollToElement("unit_owner_first_name");
        } else {
          setError("unit_owner_first_name", "");
          setValidFields((prev) => ({
            ...prev,
            unit_owner_first_name: true,
          }));
        }

        if (!validateRequired(appealRequest?.unit_owner_rest_name)) {
          setValidFields((prev) => ({
            ...prev,
            unit_owner_rest_name: false,
          }));
          setError(
            "unit_owner_rest_name",
            "يجب إدخال باقي الإسم لمالك الوحدة محل الطعن",
          );
          isFormValid = false;
          scrollToElement("unit_owner_rest_name");
        } else {
          setError("unit_owner_rest_name", "");
          setValidFields((prev) => ({
            ...prev,
            unit_owner_rest_name: true,
          }));
        }

        if (!validateRequired(appealRequest?.unit_owner_nationality_id)) {
          setValidFields((prev) => ({
            ...prev,
            unit_owner_nationality_id: false,
          }));
          setError("unit_owner_nationality_id", "يجب اختيار الجنسية");
          isFormValid = false;
          scrollToElement("unit_owner_nationality_id");
        } else {
          setError("unit_owner_nationality_id", "");
          setValidFields((prev) => ({
            ...prev,
            unit_owner_nationality_id: true,
          }));
        }

        // مصري
        if (parseInt(appealRequest?.unit_owner_nationality_id) === 63) {
          if (!validateRequired(appealRequest?.unit_owner_national_id)) {
            setValidFields((prev) => ({
              ...prev,
              unit_owner_national_id: false,
            }));
            setError(
              "unit_owner_national_id",
              "يجب إدخال الرقم القومي لمالك الوحدة محل الطعن",
            );
            isFormValid = false;
            scrollToElement("unit_owner_national_id");
          } else if (appealRequest?.unit_owner_national_id.length !== 14) {
            setValidFields((prev) => ({
              ...prev,
              unit_owner_national_id: false,
            }));
            setError(
              "unit_owner_national_id",
              "يجب إدخال الرقم القومي المكون من 14 رقمًا فقط",
            );
            isFormValid = false;
            scrollToElement("unit_owner_national_id");
          } else if (
            !validateNationalID(appealRequest?.unit_owner_national_id)
          ) {
            setError(
              "unit_owner_national_id",
              "يجب إدخال الرقم القومي المكون من 14 رقمًا فقط",
            );
            isFormValid = false;
            scrollToElement("unit_owner_national_id");
          } else {
            setError("unit_owner_national_id", "");
            setValidFields((prev) => ({
              ...prev,
              unit_owner_national_id: true,
            }));
          }

          if (
            !validateRequired(
              appealRequest?.unit_owner_national_id_attachment?.full_url,
            )
          ) {
            setError("unit_owner_national_id_attachment", "يجب رفع الصورة");
            isFormValid = false;
            scrollToElement("unit_owner_national_id_attachment");
          } else {
            setError("unit_owner_national_id_attachment", "");
          }
          setValidFields((prev) => ({
            ...prev,
            unit_owner_national_id_attachment: true,
          }));
        }
        // أجنبي
        else {
          if (!validateRequired(appealRequest?.unit_owner_passport_no)) {
            setValidFields((prev) => ({
              ...prev,
              unit_owner_passport_no: false,
            }));
            setError(
              "unit_owner_passport_no",
              "يجب إدخال رقم جواز السفر لمالك الوحدة محل الطعن",
            );
            isFormValid = false;
            scrollToElement("unit_owner_passport_no");
          } else {
            setError("unit_owner_passport_no", "");
            setValidFields((prev) => ({
              ...prev,
              unit_owner_passport_no: true,
            }));
          }

          if (
            !validateRequired(
              appealRequest?.unit_owner_passport_no_attachment?.full_url,
            )
          ) {
            setError("unit_owner_passport_no_attachment", "يجب رفع الصورة");
            isFormValid = false;
            scrollToElement("unit_owner_passport_no_attachment");
          } else {
            setError("unit_owner_passport_no_attachment", "");
          }
          setValidFields((prev) => ({
            ...prev,
            unit_owner_passport_no_attachment: true,
          }));
        }
      }

      // إعتباري
      if (parseInt(appealRequest?.unit_owner_type_id) === 2) {
        if (!validateRequired(appealRequest?.unit_owner_name)) {
          setValidFields((prev) => ({
            ...prev,
            unit_owner_name: false,
          }));
          setError("unit_owner_name", "يجب إدخال اسم مالك الوحدة محل الطعن");
          isFormValid = false;
          scrollToElement("unit_owner_name");
        } else {
          setError("unit_owner_name", "");
          setValidFields((prev) => ({
            ...prev,
            unit_owner_name: true,
          }));
        }

        if (
          !validateRequired(appealRequest?.commercial_registration_number) &&
          !validateRequired(appealRequest?.tax_number) &&
          !validateRequired(appealRequest?.unit_owner_other) &&
          !validateRequired(
            appealRequest?.commercial_registration_number_attachment,
          ) &&
          !validateRequired(appealRequest?.tax_number_attachment) &&
          !validateRequired(appealRequest?.unit_owner_other_attachment)
        ) {
          setUnitOwnerTypeErrorMessage(
            "يجب إدخال على الأقل حقل واحد من الحقول التالية: رقم السجل التجاري، الرقم الضريبي، أو أخرى",
          );
          setValidFields((prev) => ({
            ...prev,
            commercial_registration_number: false,
          }));
          setError(
            "commercial_registration_number",
            " يجب إدخال حقل واحد على الأقل من هذه الحقول",
          );
          isFormValid = false;
          scrollToElement("commercial_registration_number");
          setValidFields((prev) => ({
            ...prev,
            tax_number: false,
          }));
          setError("tax_number", " يجب إدخال حقل واحد على الأقل من هذه الحقول");
          setValidFields((prev) => ({
            ...prev,
            unit_owner_other: false,
          }));
          setError(
            "unit_owner_other",
            " يجب إدخال حقل واحد على الأقل من هذه الحقول",
          );
          isFormValid = false;
          scrollToElement("unit_owner_other");
        } else {
          setUnitOwnerTypeErrorMessage("");
          setError("commercial_registration_number", "");
          setError("tax_number", "");
          setError("unit_owner_other", "");
          setError("commercial_registration_number_attachment", "");
          setError("tax_number_attachment", "");
          setError("unit_owner_other_attachment", "");
        }

        if (validateRequired(appealRequest?.commercial_registration_number)) {
          if (
            !validateRequired(
              appealRequest?.commercial_registration_number_attachment
                ?.full_url,
            )
          ) {
            setError(
              "commercial_registration_number_attachment",
              "يجب رفع الصورة",
            );
            isFormValid = false;
            scrollToElement("commercial_registration_number_attachment");
          } else {
            setError("commercial_registration_number_attachment", "");
          }
          setValidFields((prev) => ({
            ...prev,
            commercial_registration_number_attachment: true,
          }));
        } else {
          setError("commercial_registration_number", "");
          setError("commercial_registration_number_attachment", "");
        }

        if (validateRequired(appealRequest?.tax_number)) {
          if (
            !validateRequired(appealRequest?.tax_number_attachment?.full_url)
          ) {
            setError("tax_number_attachment", "يجب رفع الصورة");
            isFormValid = false;
            scrollToElement("tax_number_attachment");
          } else {
            setError("tax_number_attachment", "");
          }
          setValidFields((prev) => ({
            ...prev,
            tax_number_attachment: true,
          }));
        } else {
          setError("tax_number", "");
          setError("tax_number_attachment", "");
        }

        if (validateRequired(appealRequest?.unit_owner_other)) {
          if (
            !validateRequired(
              appealRequest?.unit_owner_other_attachment?.full_url,
            )
          ) {
            setError("unit_owner_other_attachment", "يجب رفع الصورة");
            isFormValid = false;
            scrollToElement("unit_owner_other_attachment");
          } else {
            setError("unit_owner_other_attachment", "");
          }
          setValidFields((prev) => ({
            ...prev,
            unit_owner_other_attachment: true,
          }));
        } else {
          setError("unit_owner_other", "");
          setError("unit_owner_other_attachment", "");
        }
      }
    }

    if (!validateRequired(appealRequest?.appeal_type_id)) {
      setValidFields((prev) => ({
        ...prev,
        appeal_type_id: false,
      }));
      setError("appeal_type_id", "يجب اختيار نوع الطلب");
      isFormValid = false;
      scrollToElement("appeal_type_id");
    } else {
      setError("appeal_type_id", "");
      setValidFields((prev) => ({
        ...prev,
        appeal_type_id: true,
      }));
    }

    //  الطعن على تقديرات القيمة الإيجارية للوحدة
    if (parseInt(appealRequest?.appeal_type_id) === 1) {
      if (!validateRequired(appealRequest?.appeal_rental_value)) {
        setValidFields((prev) => ({
          ...prev,
          appeal_rental_value: false,
        }));
        setError(
          "appeal_rental_value",
          "يجب ادخال القيمة الإيجارية المطعون عليها",
        );
        isFormValid = false;
        scrollToElement("appeal_rental_value");
      } else {
        setError("appeal_rental_value", "");
        setValidFields((prev) => ({
          ...prev,
          appeal_rental_value: true,
        }));
      }

      if (!validateRequired(appealRequest?.appeal_tax_value)) {
        setValidFields((prev) => ({
          ...prev,
          appeal_tax_value: false,
        }));
        setError("appeal_tax_value", "يجب ادخال الضريبة المطعون عليها");
        isFormValid = false;
        scrollToElement("appeal_tax_value");
      } else {
        setError("appeal_tax_value", "");
        setValidFields((prev) => ({
          ...prev,
          appeal_tax_value: true,
        }));
      }

      if (!validateRequired(appealRequest?.appealed_tax_period_type_id)) {
        setValidFields((prev) => ({
          ...prev,
          appealed_tax_period_type_id: false,
        }));
        setError(
          "appealed_tax_period_type_id",
          "يجب اختيار  الفترة الضريبية المطعون عليها",
        );
        isFormValid = false;
        scrollToElement("appealed_tax_period_type_id");
      } else {
        setError("appealed_tax_period_type_id", "");
        setValidFields((prev) => ({
          ...prev,
          appealed_tax_period_type_id: true,
        }));
      }

      if (!validateRequired(appealRequest?.appeal_reasons)) {
        setValidFields((prev) => ({
          ...prev,
          appeal_reasons: false,
        }));
        setError("appeal_reasons", "يجب ادخال أسباب الطعن");
        isFormValid = false;
        scrollToElement("appeal_reasons");
      } else {
        setError("appeal_reasons", "");
        setValidFields((prev) => ({
          ...prev,
          appeal_reasons: true,
        }));
      }
    }
    // على رفض طلب رفع للوحدة
    if (parseInt(appealRequest?.appeal_type_id) === 2) {
      if (!validateRequired(appealRequest?.appeal_reason_type_id)) {
        setValidFields((prev) => ({
          ...prev,
          appeal_reason_type_id: false,
        }));
        setError("appeal_reason_type_id", "يجب اختيار أسباب الطعن");
        isFormValid = false;
        scrollToElement("appeal_reason_type_id");
      } else {
        setError("appeal_reason_type_id", "");
        setValidFields((prev) => ({
          ...prev,
          appeal_reason_type_id: true,
        }));
      }

      if (parseInt(appealRequest?.appeal_reason_type_id) === 11) {
        if (!validateRequired(appealRequest?.other_appeal_reason_type_text)) {
          setValidFields((prev) => ({
            ...prev,
            other_appeal_reason_type_text: false,
          }));
          setError("other_appeal_reason_type_text", "يجب ادخال أسباب الطعن");
          isFormValid = false;
          scrollToElement("other_appeal_reason_type_text");
        } else {
          setError("other_appeal_reason_type_text", "");
          setValidFields((prev) => ({
            ...prev,
            other_appeal_reason_type_text: true,
          }));
        }
      }
    }

    if (!validateRequired(appealRequest?.unit_address_type_id)) {
      setValidFields((prev) => ({
        ...prev,
        unit_address_type_id: false,
      }));
      setError("unit_address_type_id", "يجب اختيار  عنوان الوحدة محل الطعن");
      isFormValid = false;
      scrollToElement("unit_address_type_id");
    } else {
      setError("unit_address_type_id", "");
      setValidFields((prev) => ({
        ...prev,
        unit_address_type_id: true,
      }));
    }

    if (parseInt(appealRequest?.unit_address_type_id) === 1) {
      if (!validateRequired(appealRequest?.unit_code)) {
        setValidFields((prev) => ({
          ...prev,
          unit_code: false,
        }));
        setError("unit_code", "يجب إدخال كود الوحدة المكون من 14 رقمًا فقط");
        isFormValid = false;
        scrollToElement("unit_code");
      } else {
        setError("unit_code", "");
        setValidFields((prev) => ({
          ...prev,
          unit_code: true,
        }));
      }
    }

    if (parseInt(appealRequest?.unit_address_type_id) === 2) {
      if (!validateRequired(appealRequest?.governorate_id)) {
        setValidFields((prev) => ({
          ...prev,
          governorate_id: false,
        }));
        setError("governorate_id", "يجب اختيار المحافظة");
        isFormValid = false;
        scrollToElement("governorate_id");
      } else {
        setError("governorate_id", "");
        setValidFields((prev) => ({
          ...prev,
          unit_code: true,
        }));
      }

      if (!validateRequired(appealRequest?.district_id)) {
        setValidFields((prev) => ({
          ...prev,
          district_id: false,
        }));
        setError("district_id", "يجب اختيار المأمورية / القسم");
        isFormValid = false;
        scrollToElement("district_id");
      } else {
        setError("district_id", "");
        setValidFields((prev) => ({
          ...prev,
          district_id: true,
        }));
      }

      if (!validateRequired(appealRequest?.village_id)) {
        setValidFields((prev) => ({
          ...prev,
          village_id: false,
        }));
        setError("village_id", "يجب اختيار منطقة / شياخة");
        isFormValid = false;
        scrollToElement("village_id");
      } else {
        setError("village_id", "");
        setValidFields((prev) => ({
          ...prev,
          village_id: true,
        }));
      }

      //TODO other district
      if (parseInt(appealRequest?.village_id) === -1) {
        if (!validateRequired(appealRequest?.other_village_text)) {
          setValidFields((prev) => ({
            ...prev,
            other_village_text: false,
          }));
          setError("other_village_text", "يجب إدخال حقل أخرى");
          isFormValid = false;
          scrollToElement("other_village_text");
        } else {
          setError("other_village_text", "");
          setValidFields((prev) => ({
            ...prev,
            other_village_text: true,
          }));
        }
      }

      if (!validateRequired(appealRequest?.region_id)) {
        setValidFields((prev) => ({
          ...prev,
          region_id: false,
        }));
        setError("region_id", "يجب اختيار شارع");
        isFormValid = false;
        scrollToElement("region_id");
      } else {
        setError("region_id", "");
        setValidFields((prev) => ({
          ...prev,
          region_id: true,
        }));
      }

      //TODO other district
      if (parseInt(appealRequest?.region_id) === -1) {
        if (!validateRequired(appealRequest?.other_region_text)) {
          setValidFields((prev) => ({
            ...prev,
            other_region_text: false,
          }));
          setError("other_region_text", "يجب إدخال حقل أخرى");
          isFormValid = false;
          scrollToElement("other_region_text");
        } else {
          setError("other_region_text", "");
          setValidFields((prev) => ({
            ...prev,
            other_region_text: true,
          }));
        }
      }

      if (!validateRequired(appealRequest?.real_estate_id)) {
        setValidFields((prev) => ({
          ...prev,
          real_estate_id: false,
        }));
        setError("real_estate_id", "يجب اختيار عقار / قطعة");
        isFormValid = false;
        scrollToElement("real_estate_id");
      } else {
        setError("real_estate_id", "");
        setValidFields((prev) => ({
          ...prev,
          real_estate_id: true,
        }));
      }

      //TODO other district
      if (parseInt(appealRequest?.real_estate_id) === -1) {
        if (!validateRequired(appealRequest?.other_real_estate_text)) {
          setValidFields((prev) => ({
            ...prev,
            other_real_estate_text: false,
          }));
          setError("other_real_estate_text", "يجب إدخال حقل أخرى");
          isFormValid = false;
          scrollToElement("other_real_estate_text");
        } else {
          setError("other_real_estate_text", "");
          setValidFields((prev) => ({
            ...prev,
            other_real_estate_text: true,
          }));
        }
      }

      if (!validateRequired(appealRequest?.floor_id)) {
        setValidFields((prev) => ({
          ...prev,
          floor_id: false,
        }));
        setError("floor_id", "يجب اختيار الدور");
        isFormValid = false;
        scrollToElement("floor_id");
      } else {
        setError("floor_id", "");
        setValidFields((prev) => ({
          ...prev,
          floor_id: true,
        }));
      }

      if (!validateRequired(appealRequest?.unit_id)) {
        setValidFields((prev) => ({
          ...prev,
          unit_id: false,
        }));
        setError("unit_id", "يجب اختيار الوحدة");
        isFormValid = false;
        scrollToElement("unit_id");
      } else {
        setError("unit_id", "");
        setValidFields((prev) => ({
          ...prev,
          unit_id: true,
        }));
      }

      //TODO other district
      if (parseInt(appealRequest?.unit_id) === -1) {
        if (!validateRequired(appealRequest?.other_unit_text)) {
          setValidFields((prev) => ({
            ...prev,
            other_unit_text: false,
          }));
          setError("other_unit_text", "يجب إدخال حقل أخرى");
          isFormValid = false;
          scrollToElement("other_unit_text");
        } else {
          setError("other_unit_text", "");
          setValidFields((prev) => ({
            ...prev,
            other_unit_text: true,
          }));
        }
      }
    }

    if (!validateRequired(appealRequest?.unit_type_id)) {
      setValidFields((prev) => ({
        ...prev,
        unit_type_id: false,
      }));
      setError("unit_type_id", "يجب اختيار نوع الوحدة");
      isFormValid = false;
      scrollToElement("unit_type_id");
    } else {
      setError("unit_type_id", "");
      setValidFields((prev) => ({
        ...prev,
        unit_type_id: true,
      }));
    }

    if (parseInt(appealRequest?.unit_type_id) === 3) {
      if (!validateRequired(appealRequest?.facility_unit_type_id)) {
        setValidFields((prev) => ({
          ...prev,
          facility_unit_type_id: false,
        }));
        setError("facility_unit_type_id", "يجب اختيار نوع المنشأة");
        isFormValid = false;
        scrollToElement("facility_unit_type_id");
      } else {
        setError("facility_unit_type_id", "");
        setValidFields((prev) => ({
          ...prev,
          facility_unit_type_id: true,
        }));
      }
    }

    if (!validateRequired(appealRequest?.has_additional_attachments)) {
      setValidFields((prev) => ({
        ...prev,
        has_additional_attachments: false,
      }));
      setError("has_additional_attachments", "يجب اختيار إجابة");
      isFormValid = false;
      scrollToElement("has_additional_attachments");
    } else {
      setError("has_additional_attachments", "");
      setValidFields((prev) => ({
        ...prev,
        has_additional_attachments: true,
      }));
    }

    if (parseInt(appealRequest?.has_additional_attachments) === 2) {
      if (
        appealRequest?.acknowledge_unwillingness_submit_via_digital == false ||
        appealRequest?.acknowledge_unwillingness_submit_via_digital == null
      ) {
        setValidFields((prev) => ({
          ...prev,
          acknowledge_unwillingness_submit_via_digital: false,
        }));
        setError(
          "acknowledge_unwillingness_submit_via_digital",
          "يجب أن تقر بعدم الرغبة في تقديم مستندات عبر المنصة الإلكترونية، وتقديمها أمام اللجنة المختصة في تاريخ أول جلسة",
        );
        isFormValid = false;
        scrollToElement("acknowledge_unwillingness_submit_via_digital");
      } else {
        setError("acknowledge_unwillingness_submit_via_digital", "");
        setValidFields((prev) => ({
          ...prev,
          acknowledge_unwillingness_submit_via_digital: true,
        }));
      }
    }

    if (
      appealRequest?.acknowledge_not_submitted_same_data_before == false ||
      appealRequest?.acknowledge_not_submitted_same_data_before == null
    ) {
      setValidFields((prev) => ({
        ...prev,
        acknowledge_not_submitted_same_data_before: false,
      }));
      setError(
        "acknowledge_not_submitted_same_data_before",
        "يجب أن تقر بعدم سابقة تقديم طعن ضريبي عن ذات الوحدة في ذات الفترة الضريبية",
      );
      isFormValid = false;
      scrollToElement("acknowledge_not_submitted_same_data_before");
    } else {
      setError("acknowledge_not_submitted_same_data_before", "");
      setValidFields((prev) => ({
        ...prev,
        acknowledge_not_submitted_same_data_before: true,
      }));
    }

    if (
      appealRequest?.acknowledge_all_documents_are_correct == false ||
      appealRequest?.acknowledge_all_documents_are_correct == null
    ) {
      setValidFields((prev) => ({
        ...prev,
        acknowledge_all_documents_are_correct: false,
      }));
      setError(
        "acknowledge_all_documents_are_correct",
        "يجب أن تقر بأن جميع الصور الضوئية للمستندات المرفقة بطلب الطعن صحيحة ومطابقة للأصل وتحت مسئوليتي، وأن جميع البيانات مدونة بمعرفتي وتحت مسئوليتي القانونية",
      );
      isFormValid = false;
      scrollToElement("acknowledge_all_documents_are_correct");
    } else {
      setError("acknowledge_all_documents_are_correct", "");
      setValidFields((prev) => ({
        ...prev,
        acknowledge_all_documents_are_correct: true,
      }));
    }
    return isFormValid;
  };

  const ValidateAppealFields = async (fieldName, value) => {
    let valid = true;
    switch (fieldName) {
      // case "legal_representative_attachment":
      //   if ([4, 5, 6].includes(parseInt(appealRequest?.submitter_type_id))) {
      //     if (
      //       !validateRequired(value) &&
      //       !validateRequired(appealRequest?.legal_representative_attachment)
      //     ) {
      //       valid = false;
      //       setError("legal_representative_attachment", "يجب رفع الصورة");
      //     } else if (value && !validateFileSizeDispute(value, 5242880)) {
      //       valid = false;
      //       setError(
      //         "legal_representative_attachment",
      //         "لا يجب أن يتجاوز 5 ميجابايت"
      //       );
      //     } else if (value && !(await validateFileTypeDispute(value))) {
      //       valid = false;
      //       setError(
      //         "legal_representative_attachment",
      //         "يجب ان يكون PDF, JFIF, JPEG, JPG, PNG"
      //       );
      //     } else {
      //       setError("legal_representative_attachment", "");
      //     }
      //     setValidFields((prev) => ({
      //       ...prev,
      //       [fieldName]: valid,
      //     }));
      //   }
      //   break;
      // case "unit_owner_national_id_attachment":
      //   if ([4, 5, 6].includes(parseInt(appealRequest?.submitter_type_id))) {
      //     if (parseInt(appealRequest?.unit_owner_type_id) === 1) {
      //       if (parseInt(appealRequest?.unit_owner_nationality_id) === 63) {
      //         if (
      //           !validateRequired(value) &&
      //           !validateRequired(
      //             appealRequest?.unit_owner_national_id_attachment
      //           )
      //         ) {
      //           setError("unit_owner_national_id_attachment", "يجب رفع الصورة");
      //         } else if (value && !validateFileSizeDispute(value, 5242880)) {
      //           setError(
      //             "unit_owner_national_id_attachment",
      //             "لا يجب أن يتجاوز 5 ميجابايت"
      //           );
      //         } else if (value && !(await validateFileTypeDispute(value))) {
      //           setError(
      //             "unit_owner_national_id_attachment",
      //             "يجب ان يكون PDF, JFIF, JPEG, JPG, PNG"
      //           );
      //         } else {
      //           setError("unit_owner_national_id_attachment", "");
      //         }
      //         setValidFields((prev) => ({
      //           ...prev,
      //           unit_owner_national_id_attachment: true,
      //         }));
      //       }
      //     }
      //   }
      //   break;

      // case "unit_owner_passport_no_attachment":
      //   if ([4, 5, 6].includes(parseInt(appealRequest?.submitter_type_id))) {
      //     if (parseInt(appealRequest?.unit_owner_type_id) === 1) {
      //       if (parseInt(appealRequest?.unit_owner_nationality_id) !== 63) {
      //         if (
      //           !validateRequired(value) &&
      //           !validateRequired(
      //             appealRequest?.unit_owner_passport_no_attachment
      //           )
      //         ) {
      //           setError("unit_owner_passport_no_attachment", "يجب رفع الصورة");
      //         } else if (value && !validateFileSizeDispute(value, 5242880)) {
      //           setError(
      //             "unit_owner_passport_no_attachment",
      //             "لا يجب أن يتجاوز 5 ميجابايت"
      //           );
      //         } else if (value && !(await validateFileTypeDispute(value))) {
      //           setError(
      //             "unit_owner_passport_no_attachment",
      //             "يجب ان يكون PDF, JFIF, JPEG, JPG, PNG"
      //           );
      //         } else {
      //           setError("unit_owner_passport_no_attachment", "");
      //         }
      //         setValidFields((prev) => ({
      //           ...prev,
      //           unit_owner_passport_no_attachment: true,
      //         }));
      //       }
      //     }
      //   }
      //   break;

      // case "commercial_registration_number_attachment":
      //   if ([4, 5, 6].includes(parseInt(appealRequest?.submitter_type_id))) {
      //     if (validateRequired(appealRequest?.commercial_registration_number)) {
      //       if (
      //         !validateRequired(value) &&
      //         !validateRequired(
      //           appealRequest?.commercial_registration_number_attachment
      //         )
      //       ) {
      //         valid = false;
      //         setError(
      //           "commercial_registration_number_attachment",
      //           "يجب رفع الصورة"
      //         );
      //       } else if (value && !validateFileSizeDispute(value, 5242880)) {
      //         valid = false;
      //         setError(
      //           "commercial_registration_number_attachment",
      //           "لا يجب أن يتجاوز 5 ميجابايت"
      //         );
      //       } else if (value && !(await validateFileTypeDispute(value))) {
      //         valid = false;
      //         setError(
      //           "commercial_registration_number_attachment",
      //           "يجب ان يكون PDF, JFIF, JPEG, JPG, PNG"
      //         );
      //       } else {
      //         setError("commercial_registration_number_attachment", "");
      //       }
      //       setValidFields((prev) => ({
      //         ...prev,
      //         [fieldName]: valid,
      //       }));
      //     }
      //   }
      //   break;

      // case "tax_number_attachment":
      //   if ([4, 5, 6].includes(parseInt(appealRequest?.submitter_type_id))) {
      //     if (validateRequired(appealRequest?.tax_number)) {
      //       if (
      //         !validateRequired(value) &&
      //         !validateRequired(appealRequest?.tax_number_attachment)
      //       ) {
      //         valid = false;
      //         setError("tax_number_attachment", "يجب رفع الصورة");
      //       } else if (value && !validateFileSizeDispute(value, 5242880)) {
      //         valid = false;
      //         setError("tax_number_attachment", "لا يجب أن يتجاوز 5 ميجابايت");
      //       } else if (value && !(await validateFileTypeDispute(value))) {
      //         valid = false;
      //         setError(
      //           "tax_number_attachment",
      //           "يجب ان يكون PDF, JFIF, JPEG, JPG, PNG"
      //         );
      //       } else {
      //         setError("tax_number_attachment", "");
      //       }
      //       setValidFields((prev) => ({
      //         ...prev,
      //         [fieldName]: valid,
      //       }));
      //     }
      //   }
      //   break;

      // case "unit_owner_other_attachment":
      //   if ([4, 5, 6].includes(parseInt(appealRequest?.submitter_type_id))) {
      //     if (validateRequired(appealRequest?.unit_owner_other)) {
      //       if (
      //         !validateRequired(value) &&
      //         !validateRequired(appealRequest?.unit_owner_other_attachment)
      //       ) {
      //         valid = false;
      //         setError("unit_owner_other_attachment", "يجب رفع الصورة");
      //       } else if (value && !validateFileSizeDispute(value, 5242880)) {
      //         valid = false;
      //         setError(
      //           "unit_owner_other_attachment",
      //           "لا يجب أن يتجاوز 5 ميجابايت"
      //         );
      //       } else if (value && !(await validateFileTypeDispute(value))) {
      //         valid = false;
      //         setError(
      //           "unit_owner_other_attachment",
      //           "يجب ان يكون PDF, JFIF, JPEG, JPG, PNG"
      //         );
      //       } else {
      //         setError("unit_owner_other_attachment", "");
      //       }
      //       setValidFields((prev) => ({
      //         ...prev,
      //         [fieldName]: valid,
      //       }));
      //     }
      //   }
      //   break;

      // case "acknowledge_unwillingness_submit_via_digital":
      //   if (value == false) {
      //     valid = false;
      //     setError(
      //       "acknowledge_unwillingness_submit_via_digital",
      //       "يجب أن تقر بعدم الرغبة في تقديم مستندات عبر المنصة الإلكترونية، وتقديمها أمام اللجنة المختصة في تاريخ أول جلسة"
      //     );
      //   } else {
      //     setError("acknowledge_unwillingness_submit_via_digital", "");
      //   }
      //   setValidFields((prev) => ({
      //     ...prev,
      //     [fieldName]: valid,
      //   }));
      //   break;

      // case "acknowledge_not_submitted_same_data_before":
      //   if (value == false) {
      //     valid = false;
      //     setError(
      //       "acknowledge_not_submitted_same_data_before",
      //       "يجب أن تقر بعدم سابقة تقديم طعن ضريبي عن ذات الوحدة في ذات الفترة الضريبية"
      //     );
      //   } else {
      //     setError("acknowledge_not_submitted_same_data_before", "");
      //   }
      //   setValidFields((prev) => ({
      //     ...prev,
      //     [fieldName]: valid,
      //   }));
      //   break;

      //   case "acknowledge_all_documents_are_correct":
      //   if (value == false) {
      //     valid = false;
      //     setError(
      //       "acknowledge_all_documents_are_correct",
      //       "يجب أن تقر بأن جميع الصور الضوئية للمستندات المرفقة بطلب الطعن صحيحة ومطابقة للأصل وتحت مسئوليتي، وأن جميع البيانات مدونة بمعرفتي وتحت مسئوليتي القانونية"
      //     );
      //   } else {
      //     setError("acknowledge_all_documents_are_correct", "");
      //   }
      //   setValidFields((prev) => ({
      //     ...prev,
      //     [fieldName]: valid,
      //   }));
      //   break;

      default:
        break;
    }
    return valid;
    // setValidFields((prev) => ({
    //   ...prev,
    //   [fieldName]: valid,
    // }));
  };

  function handleChangeAppealSubmitterCharacter(
    parentCompenent,
    compenent,
    key,
    value,
  ) {
    handleChange(parentCompenent, compenent, key, value);

    if (["1", "2", "3"].includes(value)) {
      setAppealRequest((prev) => ({
        ...prev,
        legal_representative_attachment: null,
        unit_owner_national_id_attachment: null,
        unit_owner_passport_no_attachment: null,
        commercial_registration_number_attachment: null,
        tax_number_attachment: null,
        unit_owner_other_attachment: null,
      }));
      setValidFields((prev) => ({
        ...prev,
        legal_representative_attachment: true,
        unit_owner_national_id_attachment: true,

        unit_owner_passport_no_attachment: true,
        commercial_registration_number_attachment: true,
        tax_number_attachment: true,
        unit_owner_other_attachment: true,
      }));
      setNewUserError((prev) => ({
        ...prev,
        legal_representative_attachment: "",
        unit_owner_national_id_attachment: "",
        unit_owner_passport_no_attachment: "",
        commercial_registration_number_attachment: "",
        tax_number_attachment: "",
        unit_owner_other_attachment: "",
      }));
    } else {
      // setFileInputKeys((prev) => ({ ...prev, agency: Date.now() }));
      setValidFields((prev) => ({
        ...prev,
        legal_representative_attachment: false,
      }));
    }
  }

  useEffect(() => {
    if (
      appealRequest?.governorate_id !== null &&
      appealRequest?.governorate_id !== ""
    ) {
      getPaymentCommitteeDistricts(appealRequest?.governorate_id)
        .then((res) => setDistricts(res.data.data))
        .catch((err) => {
          console.log(err);
        });
    }
    if (
      appealRequest?.district_id !== null &&
      appealRequest?.district_id !== ""
    ) {
      getPaymentVillages(appealRequest?.district_id, true)
        .then((res) => setVillages(res.data.villages))
        .catch((err) => {
          console.log(err);
        });
    }

    if (
      appealRequest?.village_id !== null &&
      appealRequest?.village_id !== ""
    ) {
      getPaymentRegions(appealRequest?.village_id, true)
        .then((res) => setRegions(res.data.data))
        .catch((err) => {
          console.log(err);
        });
    }

    if (appealRequest?.region_id !== null && appealRequest?.region_id !== "") {
      getPaymentBuild(appealRequest?.region_id, true)
        .then((res) => {
          const build_options = res?.data?.builds?.map((element) => {
            if (element.build_num == "أخرى") {
              return { value: element?.id, label: element?.build_num };
            } else {
              return { value: element?.id, label: element?.build_num };
            }
          });
          setRealEstates(build_options);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    if (
      appealRequest?.real_estate_id !== null &&
      appealRequest?.real_estate_id !== ""
    ) {
      getFloorsByRealEstateId(appealRequest?.real_estate_id)
        .then((res) => {
          const part_options = res?.data?.parts?.map((element) => {
            return { value: element?.id, label: element?.name };
          });
          setFloors(part_options);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    if (appealRequest?.floor_id !== null && appealRequest?.floor_id !== "") {
      getAppealPaymentUnit(
        appealRequest?.floor_id,
        appealRequest?.real_estate_id,
      )
        .then((res) => {
          const unit_options = res?.data?.data?.map((element) => {
            return { value: element?.id, label: element?.name };
          });
          setUnits(unit_options);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  function handleChangeGov(parentCompenent, compenent, key, value) {
    // reset next levels
    resetDistrict();
    //load villages by gov id
    if (value !== "" && value) {
      getPaymentCommitteeDistricts(value)
        .then((res) => setDistricts(res.data.data))
        .catch((err) => {
          console.log(err);
        });
    } else {
      setDistricts([]);
    }
    handleChange(parentCompenent, compenent, key, value);
  }

  const handleChangeDistrict = (pc, c, key, value) => {
    // reset next levels
    resetVillage();
    //load villages by gov id
    if (value !== "" && value) {
      getPaymentVillages(value, true)
        .then((res) => {
          setVillages(res.data.villages);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setVillages([]);
      setRegions([]);
    }
    handleChange("", "", key, value);
  };

  const handleChangeVillage = (pc, c, key, value) => {
    resetRegion();
    //load villages by gov id
    if (value !== "" && value) {
      getPaymentRegions(value, true)
        .then((res) => setRegions(res.data.data))
        .catch((err) => {
          console.log(err);
        });
    } else {
      setRegions([]);
    }
    handleChange("", "", key, value);
  };

  const handleChangeRegion = (pc, c, key, value) => {
    resetRealEstate();
    if (value !== "" && value) {
      getPaymentBuild(value, true)
        .then((res) => {
          // handleChange("", "", "village_id", res.data.village.id);
          const build_options = res?.data?.builds?.map((element) => {
            if (element.build_num == "أخرى") {
              return { value: element?.id, label: element?.build_num };
            } else {
              return { value: element?.id, label: element?.build_num };
            }
          });
          setRealEstates(build_options);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setRealEstates([]);
    }
    handleChange("", "", key, value);
  };

  const handleChangeRealEstate = (pc, c, key, value) => {
    resetFloor();
    if (value !== "" && value) {
      getFloorsByRealEstateId(value)
        .then((res) => {
          const part_options = res?.data?.parts?.map((element) => {
            return { value: element?.id, label: element?.name };
          });
          setFloors(part_options);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setFloors([]);
    }
    handleChange("", "", key, value);
  };
  // TODO RESET FUNCTIONS
  const handleChangeFloor = (pc, c, key, value) => {
    resetUnit();
    if (value !== "" && value) {
      getAppealPaymentUnit(value, appealRequest?.real_estate_id)
        .then((res) => {
          const unit_options = res?.data?.data?.map((element) => {
            return { value: element?.id, label: element?.name };
          });
          setUnits(unit_options);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setUnits([]);
    }
    handleChange("", "", key, value);
  };

  function handleChange(pc, c, key, value) {
    setIsValid(ValidateAppealFields(key, value));
    if (key === "submitter_type_id") {
      setError("unit_owner_type_id", "");
      setValidFields((prev) => ({
        ...prev,
        unit_owner_type_id: false,
      }));
      setAppealRequest((prev) => ({
        ...prev,
        unit_owner_type_id: null,
      }));
      handleOwnerUnitTypeOneChange();
      handleOwnerUnitTypeTwoChange();
    }
    if (key === "unit_owner_type_id") {
      handleOwnerUnitTypeOneChange();
      handleOwnerUnitTypeTwoChange();
    }
    if (key === "unit_owner_nationality_id") {
      handleNationalityChange();
    }
    if (key === "appeal_type_id") {
      handleRequestTypeChange();
    }
    if (key === "unit_address_type_id") {
      handleAddressTypeChange();
    }
    if (key === "appeal_reason_type_id") {
      setError("other_appeal_reason_type_text", "");

      setValidFields((prev) => ({
        ...prev,
        other_appeal_reason_type_text: false,
      }));

      setAppealRequest((prev) => ({
        ...prev,
        other_appeal_reason_type_text: null,
      }));
    }
    setAppealRequest((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  const handleChangeFile = async (pc, c, key, value) => {
    try {
      setIsValid(ValidateAppealFields(key, value));
      // setError(key, "");

      const data = new FormData();
      data.append(`label`, key);
      data.append(`file`, value);

      if (value) {
        const response = await post(
          "api/tax-appeal/upload-attachments",
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          },
          data,
        );

        setAppealRequest((prev) => ({
          ...prev,
          [key]: response?.data?.data,
        }));
        setError(key, "");
        setUploadFileError(null);
      }
    } catch (error) {
      if (error.status === 422) {
        setValidFields((prev) => ({
          ...prev,
          key: false,
        }));
        setAppealRequest((prev) => ({
          ...prev,
          [key]: null,
        }));
        window.scrollTo(0, 0);
        setError(key, "يجب رفع الصورة");
        setUploadFileError(error?.response?.data?.errors?.file);
      }
    }
  };

  const handleRemoveFileForAdditionalAttachment = (id) => {
    setInputKeys((prev) => ({
      ...prev,
      [id]: (prev[document.id] || 0) + 0.1,
    }));
    setAppealRequest((prev) => ({
      ...prev,
      additional_attachments: (prev.additional_attachments || []).map((item) =>
        item.id === id
          ? {
              ...item,
              file: null,
              full_url: null,
              original_file_name: null,
              path: null,
            }
          : item,
      ),
    }));
    const inputElement = documentFileInputRef?.current[document.id];

    if (inputElement instanceof HTMLInputElement) {
      inputElement.value = null;
    }

    // if (documentFileInputRef?.current[document?.id])
    //   documentFileInputRef.current[
    //     document?.id
    //   ].value = "";
  };

  const resetDistrict = () => {
    setDistricts([]);
    setVillages([]);
    setRegions([]);
    setRealEstates([]);
    setFloors([]);
    setUnits([]);
    setAppealRequest((prev) => ({
      ...prev,
      district_id: null,
      village_id: null,
      other_village_text: null,
      region_id: null,
      other_region_text: null,
      real_estate_id: null,
      other_real_estate_text: null,
      floor_id: null,
      unit_id: null,
      other_unit_text: null,
    }));
    setNewUserError((prev) => ({
      ...prev,
      district_id: "",
      village_id: "",
      other_village_text: "",
      region_id: "",
      other_region_text: "",
      real_estate_id: "",
      other_real_estate_text: "",
      floor_id: "",
      unit_id: "",
      other_unit_text: "",
    }));
  };

  const resetVillage = () => {
    setVillages([]);
    setRegions([]);
    setRealEstates([]);
    setFloors([]);
    setUnits([]);
    setAppealRequest((prev) => ({
      ...prev,
      village_id: null,
      other_village_text: null,
      region_id: null,
      other_region_text: null,
      real_estate_id: null,
      other_real_estate_text: null,
      floor_id: null,
      unit_id: null,
      other_unit_text: null,
    }));
    setNewUserError((prev) => ({
      ...prev,
      village_id: "",
      region_id: "",
      other_region_text: "",
      real_estate_id: "",
      other_real_estate_text: "",
      floor_id: "",
      unit_id: "",
      other_unit_text: "",
    }));
  };

  const resetRegion = () => {
    setRegions([]);
    setRealEstates([]);
    setFloors([]);
    setUnits([]);
    setAppealRequest((prev) => ({
      ...prev,
      region_id: null,
      other_region_text: null,
      real_estate_id: null,
      other_real_estate_text: null,
      floor_id: null,
      unit_id: null,
      other_unit_text: null,
    }));
    setNewUserError((prev) => ({
      ...prev,
      region_id: "",
      other_region_text: "",
      real_estate_id: "",
      other_real_estate_text: "",
      floor_id: "",
      unit_id: "",
      other_unit_text: "",
    }));
  };

  const resetRealEstate = () => {
    setRealEstates([]);
    setFloors([]);
    setUnits([]);
    setAppealRequest((prev) => ({
      ...prev,
      real_estate_id: null,
      other_real_estate_text: null,
      floor_id: null,
      unit_id: null,
      other_unit_text: null,
    }));
    setNewUserError((prev) => ({
      ...prev,
      real_estate_id: "",
      other_real_estate_text: "",
      floor_id: "",
      unit_id: "",
      other_unit_text: "",
    }));
  };

  const resetFloor = () => {
    setFloors([]);
    setUnits([]);
    setAppealRequest((prev) => ({
      ...prev,
      floor_id: null,
      unit_id: null,
      other_unit_text: null,
    }));
    setNewUserError((prev) => ({
      ...prev,
      floor_id: "",
      unit_id: "",
      other_unit_text: "",
    }));
  };

  const resetUnit = () => {
    setUnits([]);
    setAppealRequest((prev) => ({
      ...prev,
      unit_id: null,
      other_unit_text: null,
    }));
    setNewUserError((prev) => ({
      ...prev,
      unit_id: "",
      other_unit_text: "",
    }));
  };

  const disableSubmitButtonCheck = () => {
    let isButtonDisabled = false;
    if (parseInt(appealRequest?.has_additional_attachments) === 1) {
      isButtonDisabled = Object.values(fileErrors).some(
        (error) => error.name !== "" || error.file !== "",
      );
    }
    if (appealRequest?.additional_attachments?.length > 10) {
      isButtonDisabled = true;
    }
    if (isSubmitting) {
      isButtonDisabled = true;
    }

    if ([4, 5, 6].includes(parseInt(appealRequest?.submitter_type_id))) {
      if (
        !validateRequired(
          appealRequest?.legal_representative_attachment?.full_url,
        )
      ) {
        isButtonDisabled = true;
      }

      if (parseInt(appealRequest?.unit_owner_type_id) === 1) {
        if (parseInt(appealRequest?.unit_owner_nationality_id) === 63) {
          if (
            !validateRequired(
              appealRequest?.unit_owner_national_id_attachment?.full_url,
            )
          ) {
            isButtonDisabled = true;
          }
        }

        if (
          appealRequest?.unit_owner_nationality_id !== null &&
          parseInt(appealRequest?.unit_owner_nationality_id) !== 63
        ) {
          if (
            !validateRequired(
              appealRequest?.unit_owner_passport_no_attachment?.full_url,
            )
          ) {
            isButtonDisabled = true;
          }
        }
      }

      if (parseInt(appealRequest?.unit_owner_type_id) === 2) {
        if (validateRequired(appealRequest?.commercial_registration_number)) {
          if (
            !validateRequired(
              appealRequest?.commercial_registration_number_attachment
                ?.full_url,
            )
          ) {
            isButtonDisabled = true;
          }
        }

        if (validateRequired(appealRequest?.tax_number)) {
          if (
            !validateRequired(appealRequest?.tax_number_attachment?.full_url)
          ) {
            isButtonDisabled = true;
          }
        }

        if (validateRequired(appealRequest?.unit_owner_other)) {
          if (
            !validateRequired(
              appealRequest?.unit_owner_other_attachment?.full_url,
            )
          ) {
            isButtonDisabled = true;
          }
        }
      }
    }

    if (parseInt(appealRequest?.unit_address_type_id) === 1) {
      if (!validateRequired(appealRequest?.unit_code)) {
        isButtonDisabled = true;
      }
      if (appealRequest?.unit_code?.length !== 14) {
        isButtonDisabled = true;
      }
    }

    return isButtonDisabled;
  };

  const handleSubmit = async (e) => {
    window.scrollTo(0, 0);
    e.preventDefault();

    setBackendError(null);
    setSubmissionError(null);
    const isFormValid = await validateBeforeSubmit();
    setIsSubmitting(false);

    let url = "api/tax-appeal/validate-for-review";

    if (appealRequest?.editMode) {
      appealRequest.appeal_request_id = appealRequest?.id;
      url = "api/tax-appeal/validate-for-review";
    }
    if (appealRequest?.disableAfterPaymentDifferentPeriod) {
      if (!appealRequest?.editMode) {
        appealRequest.linked_id = appealRequest?.id;
        appealRequest.id = null;
      } else {
        appealRequest.linked_id = appealRequest?.linked_id;
      }
    }

    if (appealRequest?.disableAfterPaymentSameBuilding) {
      if (!appealRequest?.editMode) {
        appealRequest.id = null;
      }
    }

    try {
      if (isFormValid) {
        setIsSubmitting(true);
        const response = await post(
          url,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          },
          appealRequest,
        );

        if (
          appealRequest?.disableAfterPaymentDifferentPeriod ||
          appealRequest?.disableAfterPaymentSameBuilding
        ) {
          if (!appealRequest?.editMode) {
            response.data.data.id = null;
          }
          response.data.data.disableAfterPaymentDifferentPeriod =
            appealRequest?.disableAfterPaymentDifferentPeriod;
          response.data.data.disableAfterPaymentSameBuilding =
            appealRequest?.disableAfterPaymentSameBuilding;
        }
        setAppealRequest(response?.data?.data);
        navigate("/tax-appeal/temporary", { state: appealRequest });

        setIsSubmitting(false);
      }
    } catch (error) {
      setIsSubmitting(false);
      if (error.response?.data?.errors) {
        setSubmissionError(error.response?.data?.errors);
      } else {
        setBackendError(
          error.response?.data?.data?.message || "خطأ في إرسال البيانات",
        );
      }

      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    const allValid = Object.values(validFields).every(Boolean);
    setIsValid(allValid);
  }, [validFields]);
  // Generate options for select components
  const generateOptions = (data) =>
    data?.map(({ id, name }) => ({ value: id.toString(), label: name }));

  const generateOptionsWithActive = (data) =>
    data?.map(({ id, name, active }) => ({
      value: id.toString(),
      label: name,
      isDisabled: !active,
    }));
  const handleVerifyUnitCode = async () => {
    try {
      setIsSubmitting(true);
      if (
        appealRequest?.unit_code === null ||
        appealRequest?.unit_code === ""
      ) {
        setValidFields((prev) => ({
          ...prev,
          unit_code: false,
        }));
        setError("unit_code", "يجب إدخال كود حساب الوحدة");
      } else if (appealRequest?.unit_code?.length !== 14) {
        setValidFields((prev) => ({
          ...prev,
          unit_code: false,
        }));
        setError("unit_code", "يجب إدخال كود الوحدة المكون من 14 رقمًا فقط");
      } else {
        setError("unit_code", "");
        setValidFields((prev) => ({
          ...prev,
          unit_code: true,
        }));
      }
      const data = {
        unit_code: appealRequest?.unit_code,
      };
      const verifyResponse = await verifyUnitCode(data);
      setAppealRequest((prev) => ({
        ...prev,
        governorate_text: verifyResponse?.data?.data?.governorate_text,
        district_text: verifyResponse?.data?.data?.district_text,
        village_text: verifyResponse?.data?.data?.village_text,
        street_text: verifyResponse?.data?.data?.street_text,
        build_text: verifyResponse?.data?.data?.build_text,
        floor_text: verifyResponse?.data?.data?.floor_text,
        unit_text: verifyResponse?.data?.data?.unit_text,
      }));
      setUnitIsVerified(true);
      setIsSubmitting(false);
    } catch (error) {
      setIsSubmitting(false);

      setUnitIsVerified(false);
      setAppealRequest((prev) => ({
        ...prev,
        governorate_text: null,
        district_text: null,
        village_text: null,
        street_text: null,
        build_text: null,
        floor_text: null,
        unit_text: null,
      }));
      setBackendError(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "حدث خطأ",
      );
      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    (appealRequest?.additional_attachments || [])?.forEach((document) => {
      if (!documentFileInputRef.current[document.id]) {
        documentFileInputRef.current[document.id] = createRef();
      }
    });
  }, [appealRequest?.additional_attachments]);

  const customFilter = (candidate, input) => {
    const lowerCaseInput = input.toLowerCase();
    const lowerCaseLabel = candidate.label.toLowerCase();

    return lowerCaseLabel.includes(lowerCaseInput);
  };

  return (
    <>
      {submissionError && (
        <div
          className="alert alert-danger  mt-3"
          id="backend_error"
          role="alert"
        >
          {Object.keys(submissionError).map((err, key) => (
            <li className="" key={key}>
              {submissionError[err][0]}
            </li>
          ))}
          {}
        </div>
      )}
      {uploadFileError && (
        <div
          className="alert alert-danger  mt-3"
          id="backend_error"
          role="alert"
        >
          {uploadFileError.map((i) => (
            <li className="" key={i}>
              {i}
            </li>
          ))}
          {}
        </div>
      )}
      {backendError && (
        <div
          className="alert alert-danger text-center mt-3"
          id="backend_error"
          role="alert"
        >
          {backendError}
        </div>
      )}
      <Fragment>
        <div className={`${stylesRequestData.box} box pdf-box`}>
          <h4 className={`${stylesRequestData["box-title"]} box-title mb-4`}>
            بيانات مقدم الطعن
          </h4>
          <div className="row">
            <div className="col-md-4">
              <SearchSelectElement
                mb4="mb-4"
                labelHtmlFor="submitter_type_id"
                inputId="submitter_type_id_input"
                labelClassName={`required form-label ${stylesRequestData["form-label"]}`}
                labelText="صفة مقدم الطلب"
                selectClassName={`${stylesRequestData["form-select"]} form-select`}
                selectID="submitter_type_id"
                name="submitter_type_id"
                options={generateOptions(submitterTypes)}
                default="أختار صفة مقدم الطلب.."
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={appealRequest?.submitter_type_id}
                onChange={handleChangeAppealSubmitterCharacter}
                pText={error_new_user.submitter_type_id}
                isClearable={true}
                disabled={appealRequest?.disableAfterPayment}
              />
            </div>
            {parseInt(appealRequest?.submitter_type_id) === 6 && (
              <div className="col-md-4">
                <InputElement
                  mb4="mb-4"
                  labelHtmlFor="other_submitter_type_text"
                  labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                  labelText="أخرى"
                  inputType="text"
                  maxLength={100}
                  inputClassName={`${stylesRequestData["form-control"]} form-control`}
                  inputID="other_submitter_type_text_input"
                  name="other_submitter_type_text"
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  value={appealRequest?.other_submitter_type_text || ""}
                  allowedPattern={
                    /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/
                  }
                  onChange={handleChange}
                  pText={error_new_user.other_submitter_type_text}
                  disabled={appealRequest?.disableAfterPayment}
                />
              </div>
            )}
            {appealRequest?.submitter_type_id && (
              <>
                <div className="col-md-4">
                  <InputElement
                    value={user.first_name || ""}
                    disabled={true}
                    name="tax_payer_first_name"
                    mb4="mb-4"
                    labelHtmlFor="tax_payer_first_name"
                    labelClassName={` ${stylesRequestData["form-label"]} form-label`}
                    labelText={" الإسم الأول لمقدم الطعن"}
                    inputType="text"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="tax_payer_first_name_input"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  />
                </div>
                <div className="col-md-4">
                  <InputElement
                    value={
                      `${user.father_name} ${user.grandfather_name} ${user.family_name}` ||
                      ""
                    }
                    disabled={true}
                    name="tax_payer_rest_name"
                    mb4="mb-4"
                    labelHtmlFor="tax_payer_rest_name"
                    labelClassName={`${stylesRequestData["form-label"]} form-label`}
                    labelText={"باقى الإسم لمقدم الطعن"}
                    inputType="text"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="tax_payer_rest_name_input"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  />
                </div>
                <div className="col-md-4">
                  <InputElement
                    name="email"
                    mb4="mb-4"
                    labelHtmlFor="email"
                    labelClassName={`${stylesRequestData["form-label"]} form-label`}
                    labelText="البريد الإلكترونى"
                    inputType="email"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="email_input"
                    value={user.email}
                    disabled={true}
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  />
                </div>
                <div className="col-md-4">
                  <InputElement
                    value={user.phone_number || ""}
                    disabled={true}
                    name="phone_number"
                    mb4="mb-4"
                    labelHtmlFor="phone_number"
                    labelClassName={`${stylesRequestData["form-label"]} form-label`}
                    labelText="رقم الهاتف"
                    inputType="text"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="phone_number_input"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    maxLength={11}
                  />
                </div>
                <div className="col-md-4">
                  <InputElement
                    value={user.nationality?.value || ""}
                    disabled={true}
                    name="natioanlity"
                    mb4="mb-4"
                    labelHtmlFor="natioanlity"
                    labelClassName={`${stylesRequestData["form-label"]} form-label`}
                    labelText="جنسية مقدم الطلب"
                    inputType="text"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="natioanlity_input"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  />
                </div>
                {user.nationality?.key === "EG" ? (
                  <Fragment>
                    <div className="col-md-4">
                      <InputElement
                        value={user.national_id || ""}
                        disabled={true}
                        name="national_id"
                        mb4="mb-4"
                        labelHtmlFor="national_id"
                        labelClassName={`${stylesRequestData["form-label"]} form-label`}
                        labelText="الرقم القومي لمقدم الطلب"
                        inputType="text"
                        inputClassName={`${stylesRequestData["form-control"]} form-control`}
                        inputID="national_id_input"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      />
                    </div>
                    {user.national_id_file && user.national_id_file.url && (
                      <div className="col-md-4">
                        <InputElement
                          value={"الملف"}
                          disabled={true}
                          name="national_id_file"
                          mb4="mb-4"
                          labelHtmlFor="national_id_file"
                          labelClassName={` ${stylesRequestData["form-label"]} form-label`}
                          labelText="صورة الرقم القومي لمقدم الطلب"
                          inputType="text"
                          inputClassName={`${stylesRequestData["form-control"]} form-control`}
                          inputID="national_id_file_input"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          isIcon={user.national_id_file.url ?? ""}
                          idDownload={user?.profile?.id}
                          filedDownload="nationalIdFile"
                        />
                      </div>
                    )}
                  </Fragment>
                ) : (
                  <Fragment>
                    <div className="col-md-4">
                      <InputElement
                        value={user.passport_number || ""}
                        disabled={true}
                        name="passport_number"
                        mb4="mb-4"
                        labelHtmlFor="passport_number"
                        labelClassName={` ${stylesRequestData["form-label"]} form-label`}
                        labelText="رقم جواز السفر لمقدم الطلب"
                        inputType="text"
                        inputClassName={`${stylesRequestData["form-control"]} form-control`}
                        inputID="passport_number_input"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      />
                    </div>
                    {user.passport_number_file &&
                      user.passport_number_file.url && (
                        <div className="col-md-4">
                          <InputElement
                            value={"الملف"}
                            disabled={true}
                            name="passport_number_file"
                            mb4="mb-4"
                            labelHtmlFor="passport_number_file"
                            labelClassName={`  ${stylesRequestData["form-label"]} form-label`}
                            labelText="صورة جواز السفر لمقدم الطلب"
                            inputType="text"
                            inputClassName={`${stylesRequestData["form-control"]} form-control`}
                            inputID="passport_number_file_input"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            isIcon={user.passport_number_file.url ?? ""}
                            idDownload={user?.profile?.id}
                            filedDownload="passportNumFile"
                          />
                        </div>
                      )}
                  </Fragment>
                )}
                {[4, 5, 6].includes(
                  parseInt(appealRequest?.submitter_type_id),
                ) && (
                  <>
                    <div className="col-md-4">
                      <InputElement
                        fileInputRef={agencyFileInputRef}
                        mb4="mb-4"
                        key={`agency-${fileInputKeys.agency}`}
                        inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                        labelHtmlFor="legal_representative_attachment"
                        labelClassName={` required ${stylesRequestData["form-label"]} form-label  `}
                        labelText="صورة سند التوكيل/ سند التمثيل القانوني"
                        inputType="file"
                        inputClassName={`${stylesRequestData["form-control"]} form-control`}
                        inputID="legal_representative_attachment_input"
                        name="legal_representative_attachment"
                        fileName="إرفاق ملف"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        icon="fa-solid fa-cloud-arrow-up"
                        accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                        pText={error_new_user.legal_representative_attachment}
                        onChange={handleChangeFile}
                        // serverPreview={true}
                        customServerInput={
                          appealRequest?.legal_representative_attachment !==
                          null
                            ? true
                            : false
                        }
                        disabled={appealRequest?.disableAfterPayment}
                      />
                    </div>
                  </>
                )}
              </>
            )}
          </div>
          {[4, 5, 6].includes(parseInt(appealRequest?.submitter_type_id)) && (
            <>
              {appealRequest?.legal_representative_attachment !== null && (
                <div className="col-md-4">
                  <div className=" col-2-4 d-flex border border-2  rounded-3 shadow-sm fs-6 justify-content-between bg-light py-2 px-2 align-items-center mb-3">
                    <p
                      className="mb-0 file-name fs-6"
                      title={AttachmentName(
                        appealRequest?.legal_representative_attachment
                          ?.full_url,
                      )}
                    >
                      {AttachmentName(
                        appealRequest?.legal_representative_attachment
                          ?.full_url,
                      )}
                    </p>
                    {!appealRequest?.disableAfterPayment && (
                      <div className="d-flex align-items-center py-2">
                        <span
                          type="button"
                          onClick={() => {
                            handleChange(
                              "",
                              "",
                              "legal_representative_attachment",
                              null,
                            );
                            agencyFileInputRef.current.value = null;
                            setError(
                              "legal_representative_attachment",
                              "يجب رفع الصورة",
                            );
                          }}
                          className={`text-danger border-0`}
                        >
                          <i className="fa-solid fa-trash fa-lg px-2"></i>
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </>
          )}
        </div>

        {[4, 5, 6].includes(parseInt(appealRequest?.submitter_type_id)) && (
          <>
            <div className={`${stylesRequestData.box} box pdf-box`}>
              <h4
                className={`${stylesRequestData["box-title"]} box-title mb-4`}
              >
                بيانات مالك الوحدة محل الطعن
              </h4>
              {unitOwnerTypeErrorMessage !== "" && (
                <div>
                  <p className="alert alert-danger text-end mt-3">
                    {unitOwnerTypeErrorMessage}
                  </p>
                </div>
              )}

              <div className="row">
                <div className="col-md-4">
                  <SearchSelectElement
                    mb4="mb-4"
                    labelHtmlFor="unit_owner_type_id"
                    labelClassName={`required form-label ${stylesRequestData["form-label"]}`}
                    labelText="نوع مالك الوحدة محل الطعن"
                    selectClassName={`${stylesRequestData["form-select"]} form-select`}
                    selectID="unit_owner_type_id_input"
                    name="unit_owner_type_id"
                    options={generateOptions(unitOwnerTypes)}
                    default="أختار نوع مالك الوحدة محل الطعن.."
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    key={parseInt(appealRequest?.unit_owner_type_id)}
                    value={parseInt(appealRequest?.unit_owner_type_id)}
                    onChange={handleChange}
                    pText={error_new_user.unit_owner_type_id}
                    isClearable={true}
                    disabled={appealRequest?.disableAfterPayment}
                  />
                </div>

                {appealRequest?.unit_owner_type_id && (
                  <>
                    {parseInt(appealRequest?.unit_owner_type_id) === 1 && (
                      <Fragment>
                        <div className="col-md-4">
                          <InputElement
                            value={appealRequest?.unit_owner_first_name || ""}
                            disabled={appealRequest?.disableAfterPayment}
                            name="unit_owner_first_name"
                            onChange={handleChange}
                            mb4="mb-4"
                            labelHtmlFor="unit_owner_first_name"
                            labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                            labelText="الإسم الأول لمالك الوحدة محل الطعن"
                            inputType="text"
                            inputClassName={`${stylesRequestData["form-control"]} form-control`}
                            inputID="unit_owner_type_first_name_input"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            pText={error_new_user.unit_owner_first_name}
                            allowedPattern={
                              /^(?!.*؟)(?:[A-Za-z\s]+|[\u0600-\u06FF\s]+)$/
                            }
                            maxLength={24}
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            value={appealRequest?.unit_owner_rest_name || ""}
                            disabled={appealRequest?.disableAfterPayment}
                            name="unit_owner_rest_name"
                            mb4="mb-4"
                            labelHtmlFor="unit_owner_rest_name"
                            labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                            labelText="باقي الإسم لمالك الوحدة محل الطعن"
                            inputType="text"
                            inputClassName={`${stylesRequestData["form-control"]} form-control`}
                            inputID="unit_owner_type_rest_name_input"
                            onChange={handleChange}
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            allowedPattern={
                              /^(?!.*؟)(?:[A-Za-z\s]+|[\u0600-\u06FF\s]+)$/
                            }
                            maxLength={64}
                            pText={error_new_user.unit_owner_rest_name}
                          />
                        </div>
                        <div className="col-md-4">
                          <SearchSelectElement
                            mb4="mb-4"
                            labelHtmlFor="unit_owner_nationality_id"
                            labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                            labelText="الجنسية"
                            selectClassName={`${stylesRequestData["form-select"]} form-select`}
                            selectID="unit_owner_nationality_id"
                            inputId="nationality_code_input"
                            name="unit_owner_nationality_id"
                            options={nationalitesOptions}
                            default="أختار الجنسية.."
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            pText={error_new_user.unit_owner_nationality_id}
                            value={parseInt(
                              appealRequest?.unit_owner_nationality_id,
                            )}
                            onChange={handleChange}
                            type="string"
                            disabled={appealRequest?.disableAfterPayment}
                          />
                        </div>
                        <>
                          {appealRequest?.unit_owner_nationality_id && (
                            <>
                              {parseInt(
                                appealRequest?.unit_owner_nationality_id,
                              ) === 63 ? (
                                <Fragment>
                                  <div className="col-md-4 col-sm-6">
                                    <InputElement
                                      name="unit_owner_national_id"
                                      mb4="mb-4"
                                      labelHtmlFor="unit_owner_national_id"
                                      labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                                      labelText="الرقم القومي لمالك الوحدة محل الطعن"
                                      inputType="text"
                                      inputClassName={`${stylesRequestData["form-control"]} form-control`}
                                      inputID="unit_owner_national_id_input"
                                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                      pText={
                                        error_new_user.unit_owner_national_id
                                      }
                                      value={
                                        appealRequest?.unit_owner_national_id ||
                                        ""
                                      }
                                      onChange={handleChange}
                                      allowedPattern={/^\d+$/}
                                      max={999999999999}
                                      maxLength={14}
                                      disabled={
                                        appealRequest?.disableAfterPayment
                                      }
                                    />
                                  </div>
                                  <div className="col-md-4 col-sm-6">
                                    <InputElement
                                      fileInputRef={nationalIdFileInputRef}
                                      mb4="mb-4"
                                      inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                                      labelHtmlFor="unit_owner_national_id_attachment"
                                      labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                                      labelText="صورة الرقم القومي لمالك الوحدة محل الطعن"
                                      inputType="file"
                                      inputClassName={` ${stylesRequestData["form-control"]} form-control ${stylesRequestData["fileCustom"]}`}
                                      inputID="unit_owner_national_id_attachment_input"
                                      name="unit_owner_national_id_attachment"
                                      fileName="إرفاق ملف"
                                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                      icon="fa-solid fa-cloud-arrow-up"
                                      accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                                      pText={
                                        error_new_user.unit_owner_national_id_attachment
                                      }
                                      onChange={handleChangeFile}
                                      disabled={
                                        appealRequest?.disableAfterPayment
                                      }
                                    />
                                  </div>
                                  {appealRequest?.unit_owner_national_id_attachment !==
                                    null && (
                                    <div className="col-md-4">
                                      <div className=" col-2-4 d-flex border border-2 mt-2 rounded-3 shadow-sm fs-6 justify-content-between bg-light py-2 px-2 align-items-center mb-3">
                                        <p
                                          className="mb-0 file-name fs-6"
                                          title={AttachmentName(
                                            appealRequest
                                              ?.unit_owner_national_id_attachment
                                              ?.full_url,
                                          )}
                                        >
                                          {AttachmentName(
                                            appealRequest
                                              ?.unit_owner_national_id_attachment
                                              ?.full_url,
                                          )}
                                        </p>
                                        {!appealRequest?.disableAfterPayment && (
                                          <div className="d-flex align-items-center py-2">
                                            <span
                                              type="button"
                                              onClick={() => {
                                                handleChange(
                                                  "",
                                                  "",
                                                  "unit_owner_national_id_attachment",
                                                  null,
                                                );
                                                nationalIdFileInputRef.current.value =
                                                  null;
                                                setError(
                                                  "unit_owner_national_id_attachment",
                                                  "يجب رفع الصورة",
                                                );
                                              }}
                                              className={`text-danger border-0`}
                                            >
                                              <i className="fa-solid fa-trash fa-lg px-2"></i>
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </Fragment>
                              ) : parseInt(
                                  appealRequest?.unit_owner_nationality_id,
                                ) !== 63 &&
                                appealRequest?.unit_owner_nationality_id !==
                                  "" ? (
                                <Fragment>
                                  <div className="col-md-4 col-sm-6">
                                    <InputElement
                                      name="unit_owner_passport_no"
                                      mb4="mb-4"
                                      labelHtmlFor="unit_owner_passport_no"
                                      labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                                      labelText="رقم جواز السفر لمالك الوحدة محل الطعن"
                                      inputType="text"
                                      inputClassName={`${stylesRequestData["form-control"]} form-control`}
                                      inputID="unit_owner_passport_no_input"
                                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                      pText={
                                        error_new_user.unit_owner_passport_no
                                      }
                                      value={
                                        appealRequest?.unit_owner_passport_no ||
                                        ""
                                      }
                                      onChange={handleChange}
                                      maxLength={24}
                                      allowedPattern={/^[A-Za-z0-9\-\/]+$/}
                                      disabled={
                                        appealRequest?.disableAfterPayment
                                      }
                                    />
                                  </div>
                                  <div className="col-md-4 col-sm-6">
                                    <InputElement
                                      fileInputRef={passportNumFileInputRef}
                                      mb4="mb-4"
                                      inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                                      labelHtmlFor="unit_owner_passport_no_attachment"
                                      labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                                      labelText="صورة جواز السفر لمالك الوحدة محل الطعن"
                                      inputType="file"
                                      inputClassName={`${stylesRequestData["form-control"]} form-control`}
                                      inputID="unit_owner_passport_no_attachment_input"
                                      name="unit_owner_passport_no_attachment"
                                      fileName="إرفاق ملف"
                                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                      icon="fa-solid fa-cloud-arrow-up"
                                      accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                                      pText={
                                        error_new_user.unit_owner_passport_no_attachment
                                      }
                                      onChange={handleChangeFile}
                                      disabled={
                                        appealRequest?.disableAfterPayment
                                      }
                                    />
                                  </div>
                                  {appealRequest?.unit_owner_passport_no_attachment !==
                                    null && (
                                    <div className="col-md-4">
                                      <div className=" col-2-4 d-flex border border-2 mt-2 rounded-3 shadow-sm fs-6 justify-content-between bg-light py-2 px-2 align-items-center mb-3">
                                        <p
                                          className="mb-0 file-name fs-6"
                                          title={AttachmentName(
                                            appealRequest
                                              ?.unit_owner_passport_no_attachment
                                              ?.full_url,
                                          )}
                                        >
                                          {AttachmentName(
                                            appealRequest
                                              ?.unit_owner_passport_no_attachment
                                              ?.full_url,
                                          )}
                                        </p>
                                        {!appealRequest?.disableAfterPayment && (
                                          <div className="d-flex align-items-center py-2">
                                            <span
                                              type="button"
                                              onClick={() => {
                                                handleChange(
                                                  "",
                                                  "",
                                                  "unit_owner_passport_no_attachment",
                                                  null,
                                                );
                                                passportNumFileInputRef.current.value =
                                                  null;
                                                setError(
                                                  "unit_owner_passport_no_attachment",
                                                  "يجب رفع الصورة",
                                                );
                                              }}
                                              className={`text-danger border-0`}
                                            >
                                              <i className="fa-solid fa-trash fa-lg px-2"></i>
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </Fragment>
                              ) : (
                                <Fragment></Fragment>
                              )}
                            </>
                          )}
                        </>
                      </Fragment>
                    )}
                    {parseInt(appealRequest?.unit_owner_type_id) === 2 && (
                      <Fragment>
                        <div className="col-md-4">
                          <InputElement
                            value={appealRequest?.unit_owner_name || ""}
                            name="unit_owner_name"
                            onChange={handleChange}
                            mb4="mb-4"
                            labelHtmlFor="unit_owner_name"
                            labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                            labelText="اسم مالك الوحدة محل الطعن"
                            inputType="text"
                            inputClassName={`${stylesRequestData["form-control"]} form-control`}
                            inputID="unit_owner_name_input"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            pText={error_new_user.unit_owner_name}
                            allowedPattern={
                              /^(?!.*؟)(?:[A-Za-z\s]+|[\u0600-\u06FF\s]+)$/
                            }
                            maxLength={100}
                            disabled={appealRequest?.disableAfterPayment}
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            name="commercial_registration_number"
                            mb4="mb-4"
                            labelHtmlFor="commercial_registration_number"
                            labelClassName={`${stylesRequestData["form-label"]} form-label`}
                            labelText="رقم السجل التجاري"
                            inputType="text"
                            inputClassName={`${stylesRequestData["form-control"]} form-control`}
                            inputID="commercial_registration_number_input"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            pText={
                              error_new_user.commercial_registration_number
                            }
                            value={
                              appealRequest?.commercial_registration_number ||
                              ""
                            }
                            onChange={handleChange}
                            allowedPattern={/^\d+$/}
                            maxLength={100}
                            disabled={appealRequest?.disableAfterPayment}
                          />
                        </div>
                        <div className="col-md-4 col-sm-6">
                          <InputElement
                            fileInputRef={commercialRegistrationNumberInputRef}
                            mb4="mb-4"
                            inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                            labelHtmlFor="commercial_registration_number_attachment"
                            labelClassName={`${
                              validateRequired(
                                appealRequest?.commercial_registration_number,
                              ) && "required"
                            } ${stylesRequestData["form-label"]} form-label`}
                            labelText="صورة رقم السجل التجاري"
                            inputType="file"
                            inputClassName={`${stylesRequestData["form-control"]} form-control ${stylesRequestData["fileCustom"]}`}
                            inputID="commercial_registration_number_file_input"
                            name="commercial_registration_number_attachment"
                            fileName="إرفاق ملف"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            icon="fa-solid fa-cloud-arrow-up"
                            accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                            pText={
                              error_new_user.commercial_registration_number_attachment
                            }
                            onChange={handleChangeFile}
                            hasDeleteButton={validateRequired(
                              appealRequest?.commercial_registration_number,
                            )}
                            disabled={
                              !validateRequired(
                                appealRequest?.commercial_registration_number,
                              ) || appealRequest?.disableAfterPayment
                            }
                          />
                        </div>

                        <div className="col-md-4">
                          <InputElement
                            name="tax_number"
                            mb4="mb-4"
                            labelHtmlFor="tax_number"
                            labelClassName={`${stylesRequestData["form-label"]} form-label`}
                            labelText="الرقم الضريبي"
                            inputType="text"
                            inputClassName={`${stylesRequestData["form-control"]} form-control`}
                            inputID="tax_number_input"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            pText={error_new_user.tax_number}
                            value={appealRequest?.tax_number || ""}
                            onChange={handleChange}
                            allowedPattern={/^\d+$/}
                            maxLength={100}
                            disabled={appealRequest?.disableAfterPayment}
                          />
                        </div>
                        <div className="col-md-4 col-sm-6">
                          <InputElement
                            fileInputRef={taxNumberFileInputRef}
                            mb4="mb-4"
                            inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                            labelHtmlFor="tax_number_attachment"
                            labelClassName={`${
                              validateRequired(appealRequest?.tax_number) &&
                              "required"
                            } ${stylesRequestData["form-label"]} form-label`}
                            labelText="صورة الرقم الضريبي"
                            inputType="file"
                            inputClassName={`${stylesRequestData["form-control"]} form-control ${stylesRequestData["fileCustom"]}`}
                            inputID="tax_number_file_input"
                            name="tax_number_attachment"
                            fileName="إرفاق ملف"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            icon="fa-solid fa-cloud-arrow-up"
                            accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                            pText={error_new_user.tax_number_attachment}
                            onChange={handleChangeFile}
                            hasDeleteButton={validateRequired(
                              appealRequest?.tax_number,
                            )}
                            disabled={
                              !validateRequired(appealRequest?.tax_number) ||
                              appealRequest?.disableAfterPayment
                            }
                          />
                        </div>

                        <div className="col-md-4">
                          <InputElement
                            name="unit_owner_other"
                            mb4="mb-4"
                            labelHtmlFor="unit_owner_other"
                            labelClassName={` ${
                              appealRequest?.unit_owner_other_attachment !==
                                null && "required"
                            } ${stylesRequestData["form-label"]} form-label`}
                            labelText="أخرى"
                            inputType="text"
                            inputClassName={`${stylesRequestData["form-control"]} form-control`}
                            inputID="unit_owner_other_input"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            pText={error_new_user.unit_owner_other}
                            value={appealRequest?.unit_owner_other || ""}
                            onChange={handleChange}
                            allowedPattern={
                              /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/
                            }
                            maxLength={100}
                            disabled={appealRequest?.disableAfterPayment}
                          />
                        </div>
                        <div className="col-md-4 col-sm-6">
                          <InputElement
                            fileInputRef={otherEntityFileInputRef}
                            mb4="mb-4"
                            inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                            labelHtmlFor="unit_owner_other_attachment"
                            labelClassName={`${
                              validateRequired(
                                appealRequest?.unit_owner_other,
                              ) && "required"
                            } ${stylesRequestData["form-label"]} form-label`}
                            labelText="المرفق"
                            inputType="file"
                            inputClassName={`${stylesRequestData["form-control"]} form-control ${stylesRequestData["fileCustom"]}`}
                            inputID="other_entity_file_input"
                            name="unit_owner_other_attachment"
                            fileName="إرفاق ملف"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            pText={error_new_user.unit_owner_other_attachment}
                            icon="fa-solid fa-cloud-arrow-up"
                            accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                            onChange={handleChangeFile}
                            hasDeleteButton={validateRequired(
                              appealRequest?.unit_owner_other,
                            )}
                            disabled={
                              !validateRequired(
                                appealRequest?.unit_owner_other,
                              ) || appealRequest?.disableAfterPayment
                            }
                          />
                        </div>
                        <div className="row">
                          {appealRequest?.commercial_registration_number_attachment !==
                            null && (
                            <div className="col-md-4">
                              <label
                                htmlFor="commercial_registration_number_attachment_value"
                                labelHtmlFor="commercial_registration_number_attachment"
                                className={`${stylesRequestData["form-label"]} form-label`}
                              >
                                صورة السجل التجاري
                              </label>
                              <div
                                className=" col-2-4 d-flex border border-2 rounded-3 shadow-sm fs-6 justify-content-between bg-light py-1 px-2 align-items-center mb-3"
                                name="commercial_registration_number_attachment_value"
                              >
                                <p
                                  className="mb-0 file-name fs-6"
                                  title={AttachmentName(
                                    appealRequest
                                      ?.commercial_registration_number_attachment
                                      ?.full_url,
                                  )}
                                >
                                  {AttachmentName(
                                    appealRequest
                                      ?.commercial_registration_number_attachment
                                      ?.full_url,
                                  )}
                                </p>
                                {!appealRequest?.disableAfterPayment && (
                                  <div className="d-flex align-items-center py-2">
                                    <span
                                      type="button"
                                      onClick={() => {
                                        handleChange(
                                          "",
                                          "",
                                          "commercial_registration_number_attachment",
                                          null,
                                        );
                                        commercialRegistrationNumberInputRef.current.value =
                                          null;
                                        setError(
                                          "commercial_registration_number_attachment",
                                          "يجب رفع الصورة",
                                        );
                                      }}
                                      className={`text-danger border-0`}
                                    >
                                      <i className="fa-solid fa-trash fa-lg px-2"></i>
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}

                          {appealRequest?.tax_number_attachment !== null && (
                            <div className="col-md-4">
                              <label
                                htmlFor="tax_number_attachment_value"
                                labelHtmlFor="tax_number_attachment_value"
                                className={`${stylesRequestData["form-label"]} form-label`}
                              >
                                صورة الرقم الضريبي
                              </label>
                              <div
                                className=" col-2-4 d-flex border border-2 rounded-3 shadow-sm fs-6 justify-content-between bg-light py-1 px-2 align-items-center mb-3"
                                name="tax_number_attachment_value"
                              >
                                {" "}
                                <p
                                  className="mb-0 file-name fs-6"
                                  title={AttachmentName(
                                    appealRequest?.tax_number_attachment
                                      ?.full_url,
                                  )}
                                >
                                  {AttachmentName(
                                    appealRequest?.tax_number_attachment
                                      ?.full_url,
                                  )}
                                </p>
                                {!appealRequest?.disableAfterPayment && (
                                  <div className="d-flex align-items-center py-2">
                                    <span
                                      type="button"
                                      onClick={() => {
                                        handleChange(
                                          "",
                                          "",
                                          "tax_number_attachment",
                                          null,
                                        );
                                        taxNumberFileInputRef.current.value =
                                          null;
                                        setError(
                                          "tax_number_attachment",
                                          "يجب رفع الصورة",
                                        );
                                      }}
                                      className={`text-danger border-0`}
                                    >
                                      <i className="fa-solid fa-trash fa-lg px-2"></i>
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}

                          {appealRequest?.unit_owner_other_attachment !==
                            null && (
                            <div className="col-md-4">
                              <label
                                htmlFor="unit_owner_other_attachment_value"
                                labelHtmlFor="unit_owner_other_attachment_value"
                                className={`${stylesRequestData["form-label"]} form-label`}
                              >
                                صورة المرفق
                              </label>
                              <div
                                className=" col-2-4 d-flex border border-2 rounded-3 shadow-sm fs-6 justify-content-between bg-light py-1 px-2 align-items-center mb-3"
                                name="unit_owner_other_attachment_value"
                              >
                                {" "}
                                <p
                                  className="mb-0 file-name fs-6"
                                  title={AttachmentName(
                                    appealRequest?.unit_owner_other_attachment
                                      ?.full_url,
                                  )}
                                >
                                  {AttachmentName(
                                    appealRequest?.unit_owner_other_attachment
                                      ?.full_url,
                                  )}
                                </p>
                                {!appealRequest?.disableAfterPayment && (
                                  <div className="d-flex align-items-center py-2">
                                    <span
                                      type="button"
                                      onClick={() => {
                                        handleChange(
                                          "",
                                          "",
                                          "unit_owner_other_attachment",
                                          null,
                                        );
                                        otherEntityFileInputRef.current.value =
                                          null;
                                        setError(
                                          "unit_owner_other_attachment",
                                          "يجب رفع الصورة",
                                        );
                                      }}
                                      className={`text-danger border-0`}
                                    >
                                      <i className="fa-solid fa-trash fa-lg px-2"></i>
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </Fragment>
                    )}
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </Fragment>
      <div className="box pdf-box">
        <h4 className={`${stylesRequestData["box-title"]} box-title mb-4`}>
          تفاصيل الطلب
        </h4>
        <div className="row">
          <div className="col-lg-4 col-sm-6">
            <SearchSelectElement
              mb4="mb-4"
              labelHtmlFor="appeal_type_id"
              labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
              labelText="نوع الطلب"
              selectClassName={`${stylesRequestData["form-select"]} form-select`}
              selectID="appeal_type_id"
              inputId="request_type_input"
              name="appeal_type_id"
              options={generateOptionsWithActive(appealTypes)}
              default="أختار نوع الطلب .."
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              pText={error_new_user.appeal_type_id}
              value={parseInt(appealRequest?.appeal_type_id)}
              onChange={handleChange}
              isClearable={true}
              // disabled={
              //   appealRequest?.disableAfterPayment &&
              //   appealRequest?.disableAfterPaymentDifferentPeriod
              // }
            />
          </div>
          {parseInt(appealRequest?.appeal_type_id) === 1 && (
            <>
              <div className="col-md-4 col-sm-6">
                <InputElement
                  name="appeal_rental_value"
                  mb4="mb-4"
                  labelHtmlFor="appeal_rental_value"
                  labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                  labelText="القيمة الإيجارية المطعون عليها"
                  inputType="text"
                  inputClassName={`${stylesRequestData["form-control"]} form-control`}
                  inputID="appealed_rental_value_input"
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  pText={error_new_user.appeal_rental_value}
                  value={appealRequest?.appeal_rental_value || ""}
                  onChange={handleChange}
                  allowedPattern={/^\d{0,20}(\.\d{0,2})?$/}
                  // disabled={
                  //   appealRequest?.disableAfterPayment &&
                  //   appealRequest?.disableAfterPaymentSameBuilding
                  // }
                />
              </div>
              <div className="col-md-4 col-sm-6">
                <InputElement
                  name="appeal_tax_value"
                  mb4="mb-4"
                  labelHtmlFor="appeal_tax_value"
                  labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                  labelText="الضريبة المطعون عليها"
                  inputType="text"
                  inputClassName={`${stylesRequestData["form-control"]} form-control`}
                  inputID="appealed_tax_value_input"
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  pText={error_new_user.appeal_tax_value}
                  value={appealRequest?.appeal_tax_value || ""}
                  onChange={handleChange}
                  allowedPattern={/^\d{0,20}(\.\d{0,2})?$/}
                  // disabled={
                  //   appealRequest?.disableAfterPayment &&
                  //   appealRequest?.disableAfterPaymentSameBuilding
                  // }
                />
              </div>
              <div className="col-md-4 col-sm-6">
                <SearchSelectElement
                  mb4="mb-4"
                  labelHtmlFor="appealed_tax_period_type_id"
                  labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                  labelText="الفترة الضريبية المطعون عليها"
                  selectClassName={`${stylesRequestData["form-select"]} form-select`}
                  selectID="appealed_tax_period_type_id"
                  inputId="appealed_tax_period_input"
                  name="appealed_tax_period_type_id"
                  // TODO ADjust Option
                  options={generateOptionsWithActive(appealTaxPeriods)}
                  default="أختار الفترة الضريبية المطعون عليها .."
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  pText={error_new_user.appealed_tax_period_type_id}
                  value={appealRequest?.appealed_tax_period_type_id}
                  onChange={handleChange}
                  isClearable={true}
                  // disabled={
                  //   appealRequest?.disableAfterPayment &&
                  //   appealRequest?.disableAfterPaymentSameBuilding
                  // }
                />
              </div>
              <div className="col-md-12">
                <TextAreaElement
                  mb4="mb-4"
                  labelHtmlFor="appeal_reasons"
                  labelClassName={`required form-label ${stylesRequestData["form-label"]}`}
                  labelText="أسباب الطعن"
                  inputClassName={`required ${stylesRequestData["form-control"]} form-control`}
                  inputType="text"
                  teaxtAreaID="appeal_reasons"
                  teaxtAreaClassName="form-control"
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  inputId="rental_appeal_reasons_input"
                  pText={error_new_user.appeal_reasons}
                  value={appealRequest?.appeal_reasons || ""}
                  onChange={handleChange}
                  name="appeal_reasons"
                  // disabled={
                  //   appealRequest?.disableAfterPayment &&
                  //   appealRequest?.disableAfterPaymentSameBuilding
                  // }
                  allowedPattern={
                    /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/
                  }
                  maxLength={3000}
                />
              </div>
            </>
          )}

          {parseInt(appealRequest?.appeal_type_id) === 2 && (
            <>
              <div className="col-lg-4 col-sm-6">
                <SearchSelectElement
                  mb4="mb-4"
                  labelHtmlFor="appeal_reason_type_id"
                  labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                  labelText="أسباب الطعن"
                  selectClassName={`${stylesRequestData["form-select"]} form-select`}
                  selectID="appeal_reason_type_id"
                  inputId="rejection_appeal_reasons_input"
                  name="appeal_reason_type_id"
                  options={generateOptions(appealReasonTypes)}
                  default="أختار أسباب الطعن .."
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  pText={error_new_user.appeal_reason_type_id}
                  value={appealRequest?.appeal_reason_type_id}
                  onChange={handleChange}
                  isClearable={true}
                  // disabled={
                  //   appealRequest?.disableAfterPayment &&
                  //   appealRequest?.disableAfterPaymentSameBuilding
                  // }
                />
              </div>

              {parseInt(appealRequest?.appeal_reason_type_id) === 11 && (
                <>
                  <div className="col-md-12">
                    <TextAreaElement
                      mb4="mb-4"
                      labelHtmlFor="other_appeal_reason_type_text"
                      labelClassName={`required form-label ${stylesRequestData["form-label"]}`}
                      labelText="أخري"
                      inputClassName={`required ${stylesRequestData["form-control"]} form-control`}
                      inputType="text"
                      teaxtAreaID="other_appeal_reason_type_text"
                      teaxtAreaClassName="form-control"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      inputId="rental_appeal_reasons_input"
                      pText={error_new_user.other_appeal_reason_type_text}
                      value={appealRequest?.other_appeal_reason_type_text || ""}
                      onChange={handleChange}
                      name="other_appeal_reason_type_text"
                      // disabled={
                      //   appealRequest?.disableAfterPayment &&
                      //   appealRequest?.disableAfterPaymentSameBuilding
                      // }
                      allowedPattern={
                        /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/
                      }
                      maxLength={3000}
                    />
                  </div>
                </>
              )}
            </>
          )}

          <div className="col-lg-4 col-sm-6">
            <SearchSelectElement
              mb4="mb-4"
              labelHtmlFor="unit_address_type_id"
              labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
              labelText="عنوان الوحدة محل الطعن"
              selectClassName={`${stylesRequestData["form-select"]} form-select`}
              selectID="unit_address_type_id"
              inputId="unit_address_input"
              name="unit_address_type_id"
              options={generateOptions(unitAddressTypes)}
              default="أختار عنوان الوحدة محل الطعن .."
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              pText={error_new_user.unit_address_type_id}
              value={appealRequest?.unit_address_type_id}
              onChange={handleChange}
              isClearable={true}
              disabled={appealRequest?.disableAfterPayment}
            />
          </div>
        </div>
        {parseInt(appealRequest?.unit_address_type_id) === 1 && (
          <div className="row">
            <div className="col-md-4 col-sm-6">
              <InputElement
                name="unit_code"
                mb4="mb-4"
                labelHtmlFor="unit_code"
                labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                labelText="كود الوحدة"
                inputType="text"
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="unit_code_input"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                pText={error_new_user.unit_code}
                value={appealRequest?.unit_code || ""}
                onChange={handleChange}
                allowedPattern={/^\d+$/}
                maxLength={14}
                disabled={
                  appealRequest?.disableAfterPayment &&
                  appealRequest?.disableAfterPaymentDifferentPeriod
                }
              />
            </div>
            <div className="col-md-4 col-sm-6">
              <button
                type="button"
                className={` ${
                  isSubmitting
                    ? stylesRequestData["btn-request-disabled"]
                    : stylesRequestData["btn-request"]
                } w-100 w-md-75 mb-2 mb-md-0`}
                onClick={handleVerifyUnitCode}
                style={{ marginTop: "30px" }}
                id="verify_unit_code"
                disabled={
                  (appealRequest?.disableAfterPayment &&
                    appealRequest?.disableAfterPaymentDifferentPeriod) ||
                  isSubmitting
                }
              >
                التحقق من كود الوحدة
              </button>
            </div>
          </div>
        )}
        {parseInt(appealRequest?.unit_address_type_id) === 1 &&
          unitIsVerified && (
            <div className="row">
              <div className="col-lg-4 col-sm-6">
                <InputElement
                  name="governorate_text"
                  mb4="mb-4"
                  labelHtmlFor="governorate_text"
                  labelClassName={`${stylesRequestData["form-label"]} form-label`}
                  labelText="المحافظة"
                  inputType="governorate_text"
                  inputClassName={`${stylesRequestData["form-control"]} form-control`}
                  inputID="governorate_text_input"
                  value={appealRequest?.governorate_text}
                  disabled={true}
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                />
              </div>
              <div className="col-lg-4 col-sm-6">
                <InputElement
                  name="district_text"
                  mb4="mb-4"
                  labelHtmlFor="district_text"
                  labelClassName={`${stylesRequestData["form-label"]} form-label`}
                  labelText="المأمورية / القسم"
                  inputType="district_text"
                  inputClassName={`${stylesRequestData["form-control"]} form-control`}
                  inputID="district_text_input"
                  value={appealRequest?.district_text}
                  disabled={true}
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                />
              </div>
              <div className="col-lg-4 col-sm-6">
                <InputElement
                  name="village_text"
                  mb4="mb-4"
                  labelHtmlFor="village_text"
                  labelClassName={`${stylesRequestData["form-label"]} form-label`}
                  labelText="منطقة / شياخة"
                  inputType="village_text"
                  inputClassName={`${stylesRequestData["form-control"]} form-control`}
                  inputID="village_text_input"
                  value={appealRequest?.village_text}
                  disabled={true}
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                />
              </div>
              <div className="col-lg-4 col-sm-6">
                <InputElement
                  name="street_text"
                  mb4="mb-4"
                  labelHtmlFor="street_text"
                  labelClassName={`${stylesRequestData["form-label"]} form-label`}
                  labelText="شارع"
                  inputType="street_text"
                  inputClassName={`${stylesRequestData["form-control"]} form-control`}
                  inputID="street_text_input"
                  value={appealRequest?.street_text}
                  disabled={true}
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                />
              </div>
              <div className="col-lg-4 col-sm-6">
                <InputElement
                  name="build_text"
                  mb4="mb-4"
                  labelHtmlFor="build_text"
                  labelClassName={`${stylesRequestData["form-label"]} form-label`}
                  labelText="عقار / قطعة"
                  inputType="build_text"
                  inputClassName={`${stylesRequestData["form-control"]} form-control`}
                  inputID="build_text_input"
                  value={appealRequest?.build_text}
                  disabled={true}
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                />
              </div>
              <div className="col-lg-4 col-sm-6">
                <InputElement
                  name="floor_text"
                  mb4="mb-4"
                  labelHtmlFor="floor_text"
                  labelClassName={`${stylesRequestData["form-label"]} form-label`}
                  labelText="الدور"
                  inputType="floor_text"
                  inputClassName={`${stylesRequestData["form-control"]} form-control`}
                  inputID="floor_text_input"
                  value={appealRequest?.floor_text}
                  disabled={true}
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                />
              </div>
              <div className="col-lg-4 col-sm-6">
                <InputElement
                  name="unit_text"
                  mb4="mb-4"
                  labelHtmlFor="unit_text"
                  labelClassName={`${stylesRequestData["form-label"]} form-label`}
                  labelText="الوحدة"
                  inputType="unit_text"
                  inputClassName={`${stylesRequestData["form-control"]} form-control`}
                  inputID="unit_text_input"
                  value={appealRequest?.unit_text}
                  disabled={true}
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                />
              </div>
            </div>
          )}
        {parseInt(appealRequest?.unit_address_type_id) === 2 && (
          <>
            <div className="row">
              <div className="col-lg-4 col-sm-6">
                <SearchSelectElement
                  mb4="mb-4"
                  labelHtmlFor="governorate_id"
                  labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                  labelText="المحافظة"
                  selectClassName={`${stylesRequestData["form-select"]} form-select`}
                  selectID="governorate_id"
                  inputId="governorate_id_input"
                  name="governorate_id"
                  options={generateOptions(govs)}
                  default="أختار المحافظة.."
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  pText={error_new_user.governorate_id}
                  value={appealRequest?.governorate_id}
                  // key={parseInt(appealRequest?.governorate_id)}
                  onChange={handleChangeGov}
                  isClearable={true}
                  disabled={appealRequest?.disableAfterPayment}
                />
              </div>
              <div className="col-lg-4 col-sm-6">
                <SearchSelectElement
                  mb4="mb-4"
                  labelHtmlFor="district_id"
                  labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                  labelText="المأمورية / القسم"
                  selectClassName={`${stylesRequestData["form-select"]} form-select`}
                  selectID="district_id"
                  inputId="district_id_input"
                  name="district_id"
                  options={generateOptions(districts)}
                  default="أختار المأمورية / القسم.."
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  pText={error_new_user.district_id}
                  value={appealRequest?.district_id}
                  // key={parseInt(appealRequest?.district_id)}
                  onChange={handleChangeDistrict}
                  isClearable={true}
                  disabled={appealRequest?.disableAfterPayment}
                />
              </div>
              <div className="col-lg-4 col-sm-6">
                <SearchSelectElement
                  mb4="mb-4"
                  labelHtmlFor="village_id"
                  labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                  labelText="منطقة / شياخة"
                  selectClassName={`${stylesRequestData["form-select"]} form-select`}
                  selectID="village_id"
                  inputId="village_id_input"
                  name="village_id"
                  options={generateOptions(villages)}
                  default="أختار منطقة / شياخة.."
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  pText={error_new_user.village_id}
                  value={appealRequest?.village_id}
                  // key={parseInt(appealRequest?.village_id)}
                  onChange={handleChangeVillage}
                  isClearable={true}
                  disabled={appealRequest?.disableAfterPayment}
                />
              </div>
              {parseInt(appealRequest?.village_id) === -1 && (
                <div className="col-lg-4 col-sm-6">
                  <InputElement
                    mb4="mb-4"
                    labelHtmlFor="other_village_text"
                    labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                    labelText="أخرى"
                    inputType="text"
                    maxLength={100}
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="other_village_text_input"
                    name="other_village_text"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    value={appealRequest?.other_village_text || ""}
                    allowedPattern={
                      /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/
                    }
                    onChange={handleChange}
                    pText={error_new_user.other_village_text}
                    key={parseInt(appealRequest?.other_village_text)}
                    disabled={appealRequest?.disableAfterPayment}
                  />
                </div>
              )}

              <div className="col-lg-4 col-sm-6">
                <SearchSelectElement
                  mb4="mb-4"
                  labelHtmlFor="region_id"
                  labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                  labelText="شارع"
                  selectClassName={`${stylesRequestData["form-select"]} form-select`}
                  selectID="region_id"
                  inputId="region_id_input"
                  name="region_id"
                  options={generateOptions(regions)}
                  default="أختار الشارع   .."
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  pText={error_new_user.region_id}
                  value={appealRequest?.region_id}
                  onChange={handleChangeRegion}
                  isClearable={true}
                  disabled={appealRequest?.disableAfterPayment}
                />
              </div>
              {parseInt(appealRequest?.region_id) === -1 && (
                <div className="col-lg-4 col-sm-6">
                  <InputElement
                    mb4="mb-4"
                    labelHtmlFor="other_region_text"
                    labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                    labelText="أخرى"
                    inputType="text"
                    maxLength={100}
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="other_region_text_input"
                    name="other_region_text"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    value={appealRequest?.other_region_text || ""}
                    allowedPattern={
                      /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/
                    }
                    onChange={handleChange}
                    pText={error_new_user.other_region_text}
                    disabled={appealRequest?.disableAfterPayment}
                  />
                </div>
              )}

              <div className="col-lg-4 col-sm-6">
                <SearchSelectElement
                  mb4="mb-4"
                  labelHtmlFor="real_estate_id"
                  labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                  labelText="عقار / قطعة"
                  selectClassName={`${stylesRequestData["form-select"]} form-select`}
                  selectID="real_estate_id"
                  inputId="real_estate_id_input"
                  name="real_estate_id"
                  options={realEstates}
                  default="أختار عقار / قطعة.."
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  pText={error_new_user.real_estate_id}
                  value={appealRequest?.real_estate_id}
                  onChange={handleChangeRealEstate}
                  isClearable={true}
                  disabled={appealRequest?.disableAfterPayment}
                  filterOption={customFilter}
                />
              </div>
              {parseInt(appealRequest?.real_estate_id) === -1 && (
                <div className="col-lg-4 col-sm-6">
                  <InputElement
                    mb4="mb-4"
                    labelHtmlFor="other_real_estate_text"
                    labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                    labelText="أخرى"
                    inputType="text"
                    maxLength={100}
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="other_real_estate_text_input"
                    name="other_real_estate_text"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    value={appealRequest?.other_real_estate_text || ""}
                    allowedPattern={
                      /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/
                    }
                    onChange={handleChange}
                    pText={error_new_user.other_real_estate_text}
                    disabled={appealRequest?.disableAfterPayment}
                  />
                </div>
              )}

              <div className="col-lg-4 col-sm-6">
                <SearchSelectElement
                  mb4="mb-4"
                  labelHtmlFor="floor_id"
                  labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                  labelText="الدور"
                  selectClassName={`${stylesRequestData["form-select"]} form-select`}
                  selectID="floor_id"
                  inputId="floor_id_input"
                  name="floor_id"
                  options={floors}
                  default="أختار الدور.."
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  pText={error_new_user.floor_id}
                  value={appealRequest?.floor_id}
                  onChange={handleChangeFloor}
                  isClearable={true}
                  disabled={
                    appealRequest?.disableAfterPayment &&
                    appealRequest?.disableAfterPaymentDifferentPeriod &&
                    !appealRequest?.disableAfterPaymentSameBuilding
                  }
                />
              </div>

              <div className="col-lg-4 col-sm-6">
                <SearchSelectElement
                  mb4="mb-4"
                  labelHtmlFor="unit_id"
                  labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                  labelText="الوحدة"
                  selectClassName={`${stylesRequestData["form-select"]} form-select`}
                  selectID="unit_id"
                  inputId="unit_id_input"
                  name="unit_id"
                  options={units}
                  default="أختار الوحدة.."
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  pText={error_new_user.unit_id}
                  value={appealRequest?.unit_id}
                  onChange={handleChange}
                  isClearable={true}
                  disabled={
                    appealRequest?.disableAfterPayment &&
                    appealRequest?.disableAfterPaymentDifferentPeriod &&
                    !appealRequest?.disableAfterPaymentSameBuilding
                  }
                />
              </div>
              {parseInt(appealRequest?.unit_id) === -1 && (
                <div className="col-lg-4 col-sm-6">
                  <InputElement
                    mb4="mb-4"
                    labelHtmlFor="other_unit_text"
                    labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                    labelText="أخرى"
                    inputType="text"
                    maxLength={100}
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="other_unit_text_input"
                    name="other_unit_text"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    value={appealRequest?.other_unit_text || ""}
                    allowedPattern={
                      /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/
                    }
                    onChange={handleChange}
                    pText={error_new_user.other_unit_text}
                    isClearable={true}
                    disabled={
                      appealRequest?.disableAfterPayment &&
                      appealRequest?.disableAfterPaymentDifferentPeriod &&
                      !appealRequest?.disableAfterPaymentSameBuilding
                    }
                  />
                </div>
              )}
            </div>
          </>
        )}

        <div className="row">
          <div className="col-lg-4 col-sm-6">
            <SearchSelectElement
              mb4="mb-4"
              labelHtmlFor="unit_type_id"
              labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
              labelText="نوع الوحدة"
              selectClassName={`${stylesRequestData["form-select"]} form-select`}
              selectID="unit_type_id"
              inputId="unit_type_input"
              name="unit_type_id"
              options={generateOptions(unitTypes)}
              default="أختار نوع الوحدة.."
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              pText={error_new_user.unit_type_id}
              value={appealRequest?.unit_type_id}
              onChange={handleChange}
              isClearable={true}
              disabled={
                appealRequest?.disableAfterPayment &&
                appealRequest?.disableAfterPaymentDifferentPeriod &&
                !appealRequest?.disableAfterPaymentSameBuilding
              }
            />
          </div>

          {parseInt(appealRequest?.unit_type_id) === 3 && (
            <div className="col-lg-4 col-sm-6">
              <SearchSelectElement
                mb4="mb-4"
                labelHtmlFor="facility_unit_type_id"
                labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                labelText="نوع المنشأة"
                selectClassName={`${stylesRequestData["form-select"]} form-select`}
                selectID="facility_unit_type_id"
                inputId="facility_type_input"
                name="facility_unit_type_id"
                options={generateOptions(facilityTypes)}
                default="أختار نوع المنشأة.."
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                pText={error_new_user.facility_unit_type_id}
                value={appealRequest?.facility_unit_type_id}
                onChange={handleChange}
                isClearable={true}
                disabled={
                  appealRequest?.disableAfterPayment &&
                  appealRequest?.disableAfterPaymentDifferentPeriod &&
                  !appealRequest?.disableAfterPaymentSameBuilding
                }
              />
            </div>
          )}
        </div>
      </div>

      <div className="box pdf-box">
        <h4 className={`${stylesRequestData["box-title"]} box-title mb-4`}>
          قائمة المستندات الإضافية الداعمة للطلب
        </h4>
        <div className="col-lg-4 col-sm-6">
          <SearchSelectElement
            mb4="mb-4"
            labelHtmlFor="has_additional_attachments"
            labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
            labelText="هل ترغب في تحميل المستندات الإضافية الداعمة للطلب؟"
            selectClassName={`${stylesRequestData["form-select"]} form-select`}
            selectID="has_additional_attachments"
            inputId="has_additional_attachments_input"
            name="has_additional_attachments"
            options={generateOptions(doYouWantExtraAttachments)}
            default="أختار.."
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
            pText={error_new_user.has_additional_attachments}
            value={appealRequest?.has_additional_attachments}
            onChange={handleChange}
            isClearable={true}
          />
        </div>
        {parseInt(appealRequest?.has_additional_attachments) === 1 &&
          appealRequest?.additional_attachments?.length > 0 && (
            <>
              {appealRequest?.additional_attachments?.map((document, index) => {
                return (
                  <div className="row " key={document.id}>
                    <div className="col-12 col-md-4 ">
                      <InputElement
                        value={document.name || ""}
                        name="name"
                        onChange={(e) => {
                          updateDocumentName(document.id, e?.target?.value);
                        }}
                        mb4="mb-4"
                        labelHtmlFor="name"
                        labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                        labelText="اسم المستند"
                        inputType="text"
                        inputClassName={`${stylesRequestData["form-control"]} form-control`}
                        inputID="document_name_input"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        pText={fileErrors[document.id]?.name || ""}
                        allowedPattern={
                          /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-.\/\s']+$/
                        }
                        maxLength={100}
                        customChange={true}
                      />
                    </div>
                    <div className="col-12 col-md-4 ">
                      <InputElement
                        key={inputKeys[document.id] || 0}
                        fileInputRef={documentFileInputRef.current[document.id]}
                        labelHtmlFor="file"
                        labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                        labelText="اختيار ملف"
                        name="file"
                        inputType="file"
                        fileName="إرفاق ملف"
                        inputID={`document_file_input_${document.id}`}
                        inputClassName={`${stylesRequestData["form-control"]} form-control ${stylesRequestData["fileCustom"]}`}
                        inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                        icon="fa-solid fa-cloud-arrow-up"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        pText={fileErrors[document.id]?.file || ""}
                        onChange={async (parent, component, name, file) => {
                          if (file) {
                            if (!validateRequired(file)) {
                              setFileErrorById(
                                document.id,
                                "name",
                                "يجب رفع الصورة",
                              );
                              return;
                            }

                            setFileErrorById(document.id, "name", "");
                            setFileErrorById(document.id, "file", "");

                            updateDocumentFile(document.id, file);
                          }
                        }}
                        accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                        disabled={!validateRequired(document.name)}
                      />
                    </div>
                    {/* {appealRequest?.unit_owner_other_attachment !== null && ( */}

                    {/* )} */}
                    <div className="col-md-4 col-sm-6 row gap-2">
                      <div className="col-md-5 col-sm-6 ">
                        {appealRequest?.additional_attachments?.length > 1 &&
                          index !== 0 && (
                            <button
                              onClick={() => removeAttachmentById(document.id)}
                              className={` ${stylesRequestData["btn-delete"]} text-danger`}
                              style={{ marginTop: "33px" }}
                            >
                              حذف المستند{" "}
                              <i className="fa-regular fa-trash-can fa-lg ml-1"></i>
                            </button>
                          )}
                      </div>
                      {index ===
                        appealRequest?.additional_attachments.length - 1 && (
                        <div className="col-md-5 col-sm-6 ">
                          <button
                            onClick={() => addAttachment()}
                            className={` ${
                              !validateRequired(document.name) ||
                              !validateRequired(document.path) ||
                              appealRequest?.additional_attachments.length ===
                                10
                                ? stylesRequestData["btn-add-disabled"]
                                : stylesRequestData["btn-add"]
                            } `}
                            style={{ marginTop: "33px" }}
                          >
                            إضافة مستند آخر
                          </button>
                        </div>
                      )}
                    </div>
                    {document?.full_url && (
                      <div className="col-md-4 col-sm-6">
                        <label
                          htmlFor="document_file_value"
                          labelHtmlFor="document_file_value"
                          className={`${stylesRequestData["form-label"]} form-label`}
                        >
                          صورة المرفق
                        </label>
                        <div
                          className=" col-2-4 d-flex border border-2 rounded-3 shadow-sm fs-6 justify-content-between bg-light py-1 px-2 align-items-center mb-3"
                          name="document_file_value"
                        >
                          <p
                            className="mb-0 file-name fs-6"
                            title={AttachmentName(document?.full_url)}
                          >
                            {AttachmentName(document?.full_url)}
                          </p>
                          <div className="d-flex align-items-center py-2">
                            <span
                              type="button"
                              onClick={() =>
                                handleRemoveFileForAdditionalAttachment(
                                  document?.id,
                                )
                              }
                              className={`text-danger border-0`}
                            >
                              <i className="fa-solid fa-trash fa-lg px-2"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </>
          )}

        {parseInt(appealRequest?.has_additional_attachments) === 2 && (
          <>
            <div className="list-group border-0">
              <label
                htmlFor="date"
                className={`required ${stylesRequestData["list-group-item"]} list-group-item border-0`}
              >
                <input
                  type="checkbox"
                  className={`${stylesRequestData["form-check-input"]} form-check-input ms-3`}
                  name="acknowledge_unwillingness_submit_via_digital"
                  id="acknowledge_unwillingness_submit_via_digital"
                  checked={
                    appealRequest?.acknowledge_unwillingness_submit_via_digital
                  }
                  onChange={(e) =>
                    handleChange(
                      "",
                      "",
                      "acknowledge_unwillingness_submit_via_digital",
                      e.target.checked ? 1 : 0,
                    )
                  }
                />
                <span style={{ fontSize: "15px" }}>
                  {
                    "أقر بعدم رغبتي في تقديم مستندات عبر المنصة الإلكترونية، وتقديمها أمام اللجنة المختصة في تاريخ أول جلسة"
                  }
                </span>
              </label>
              {error_new_user.acknowledge_unwillingness_submit_via_digital && (
                <p
                  className="text-danger mb-0 mt-1 me-4 fw-bolder"
                  id="acknowledge_unwillingness_to_submit_documents_error"
                >
                  {error_new_user.acknowledge_unwillingness_submit_via_digital}
                </p>
              )}
            </div>
          </>
        )}
      </div>
      <div className="box pdf-box">
        <div className="row">
          <div className="list-group border-0">
            <label
              htmlFor="date"
              className={`required ${stylesRequestData["list-group-item"]} list-group-item border-0`}
            >
              <input
                type="checkbox"
                className={`${stylesRequestData["form-check-input"]} form-check-input ms-3`}
                name="acknowledge_not_submitted_same_data_before"
                id="acknowledge_not_submitted_same_data_before"
                checked={
                  appealRequest?.acknowledge_not_submitted_same_data_before
                }
                onChange={(e) =>
                  handleChange(
                    "",
                    "",
                    "acknowledge_not_submitted_same_data_before",
                    e.target.checked ? 1 : 0,
                  )
                }
              />
              <span style={{ fontSize: "15px" }}>
                {
                  "أقر بعدم سابقة تقديم طعن ضريبي عن ذات الوحدة في ذات الفترة الضريبية"
                }
              </span>
            </label>
            {error_new_user.acknowledge_not_submitted_same_data_before && (
              <p
                className="text-danger mb-0 mt-1 me-4 fw-bolder"
                id="acknowledge_tax_period_error"
              >
                {error_new_user.acknowledge_not_submitted_same_data_before}
              </p>
            )}
          </div>
          <div className="list-group border-0">
            <label
              htmlFor="date"
              className={`required ${stylesRequestData["list-group-item"]} list-group-item border-0`}
            >
              <input
                type="checkbox"
                className={`${stylesRequestData["form-check-input"]} form-check-input ms-3`}
                name="acknowledge_all_documents_are_correct"
                id="acknowledge_all_documents_are_correct"
                checked={appealRequest?.acknowledge_all_documents_are_correct}
                onChange={(e) =>
                  handleChange(
                    "",
                    "",
                    "acknowledge_all_documents_are_correct",
                    e.target.checked ? 1 : 0,
                  )
                }
              />
              <span style={{ fontSize: "15px" }}>
                {
                  "أقر بأن جميع الصور الضوئية للمستندات المرفقة بطلب الطعن صحيحة ومطابقة للأصل وتحت مسئوليتي، وأن جميع البيانات مدونة بمعرفتي وتحت مسئوليتي القانونية"
                }
              </span>
            </label>
            {error_new_user.acknowledge_all_documents_are_correct && (
              <p
                className="text-danger mb-0 mt-1 me-4 fw-bolder"
                id="acknowledge_photocopies_tax_period_error"
              >
                {error_new_user.acknowledge_all_documents_are_correct}
              </p>
            )}
          </div>
        </div>

        <div className="d-flex flex-lg-row flex-column justify-content-start  gap-3  align-items-center pb-5 mt-4 pt-5">
          <button
            type="button"
            className={` ${
              disableSubmitButtonCheck() ||
              isButtonDisabledIfAttachmentFilesAreNotValid
                ? stylesRequestData["btn-request-disabled"]
                : stylesRequestData["btn-request"]
            } `}
            onClick={handleSubmit}
            id="submit_request_data"
          >
            إرسال طلب الطعن
          </button>
          <button
            onClick={() => {
              navigate("/tax-appeal/list-data", {
                state: { message: "تم إلغاء تقديم الطلب" },
              });
            }}
            className={` ${stylesRequestData["btn-login"]} `}
            id="cancel_request_data"
          >
            إلغاء
          </button>
        </div>
      </div>
    </>
  );
};

export default AppealRequestData;
